import { B as At, a as It, H as Re, R as Jr } from "./RouteGuard-Vnlz_t51.js";
import { z as Rt, M as Xr, J as en, u as tn } from "./index-Bm35Tkgf.js";
import { R as rn, S as nn, u as xe, e as De, f as on, L as Me, O as Dt } from "./chunk-DQRVZFIR-DHK7_Ilc.js";
import { S as Mt, v as Ft, Q as sn, n as R, w as Ge, x as Je, i as L, y as an, z as cn, A as un, B as ln, D as Xe, E as et, F as dn, h as tt, G as rt, H as fn, I as hn, g as qt, J as Ut, l as pn, d as M, e as oe, K as Lt, L as Qt, j as ee, M as mn, u as gn, c as vn, N as yn, Z as xn, f as _n, C as bn } from "./hook-CZjW2buS.js";
import { h as wn, E as Bt, a as A, A as jn, i as kn, s as $n, N as nt, j as zn, T as Kt, C as Pn, H as En, k as Sn, l as Zn, m as Cn, V as Tn, R as Nn, M as On } from "./Slot-B31yZlfB.js";
import { j as s } from "./jsx-runtime-C5mzlN2N.js";
import { Button as Ht } from "./ui/Button.js";
import { Callout as An } from "./ui/Callout.js";
import * as K from "react";
import { createContext as Fe, StrictMode as Wt, useRef as H, useEffect as F, useState as G, useCallback as B, Suspense as qe, Fragment as In, memo as Vt, Component as Rn, createElement as ot, useMemo as $e, useContext as Dn } from "react";
import * as Mn from "react-dom";
import { CircleFadingArrowUpIcon as Fn, LoaderCircleIcon as qn, ExternalLink as Un, CircleXIcon as Ln, ChevronRightIcon as Qn, SearchIcon as Bn, SunIcon as Kn, MoonIcon as Hn, MenuIcon as Wn, PanelLeftIcon as Vn } from "lucide-react";
import { C as te } from "./ClientOnly-E7hGysn1.js";
import { c as O } from "./cn-dYga0KKN.js";
import { S as Yt } from "./Spinner-mNLZ6awP.js";
import { isSearchPlugin as Yn, isProfileMenuPlugin as Gt, isNavigationPlugin as st, isAuthenticationPlugin as Gn, isEventConsumerPlugin as Jn, needsInitialization as Xn, isApiIdentityPlugin as eo, isMdxProviderPlugin as to, hasHead as ro } from "./zudoku.plugins.js";
import { B as Se } from "./Button-B3o-2Xdf.js";
import { DropdownMenu as no, DropdownMenuTrigger as oo, DropdownMenuContent as so, DropdownMenuLabel as io, DropdownMenuSeparator as ze, DropdownMenuSub as ao, DropdownMenuSubTrigger as co, DropdownMenuPortal as uo, DropdownMenuSubContent as lo, DropdownMenuItem as fo } from "./ui/DropdownMenu.js";
import { VisuallyHidden as Jt } from "@radix-ui/react-visually-hidden";
import { D as ho, a as po, b as Xt, c as er, d as q } from "./Drawer-DJ05s2pH.js";
import { a as mo } from "./index-DI5SPFK9.js";
var go = class extends Mt {
  constructor(e = {}) {
    super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
  }
  #e;
  build(e, t, r) {
    const n = t.queryKey, o = t.queryHash ?? Ft(n, t);
    let i = this.get(o);
    return i || (i = new sn({
      client: e,
      queryKey: n,
      queryHash: o,
      options: e.defaultQueryOptions(t),
      state: r,
      defaultOptions: e.getQueryDefaults(n)
    }), this.add(i)), i;
  }
  add(e) {
    this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = this.#e.get(e.queryHash);
    t && (e.destroy(), t === e && this.#e.delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.#e.get(e);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => Ge(t, r)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((r) => Ge(e, r)) : t;
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    R.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, vo = class extends Mt {
  constructor(e = {}) {
    super(), this.config = e, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#r = 0;
  }
  #e;
  #t;
  #r;
  build(e, t, r) {
    const n = new wn({
      mutationCache: this,
      mutationId: ++this.#r,
      options: e.defaultMutationOptions(t),
      state: r
    });
    return this.add(n), n;
  }
  add(e) {
    this.#e.add(e);
    const t = ue(e);
    if (typeof t == "string") {
      const r = this.#t.get(t);
      r ? r.push(e) : this.#t.set(t, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (this.#e.delete(e)) {
      const t = ue(e);
      if (typeof t == "string") {
        const r = this.#t.get(t);
        if (r)
          if (r.length > 1) {
            const n = r.indexOf(e);
            n !== -1 && r.splice(n, 1);
          } else r[0] === e && this.#t.delete(t);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const t = ue(e);
    if (typeof t == "string") {
      const n = this.#t.get(t)?.find(
        (o) => o.state.status === "pending"
      );
      return !n || n === e;
    } else
      return !0;
  }
  runNext(e) {
    const t = ue(e);
    return typeof t == "string" ? this.#t.get(t)?.find((n) => n !== e && n.state.isPaused)?.continue() ?? Promise.resolve() : Promise.resolve();
  }
  clear() {
    R.batch(() => {
      this.#e.forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), this.#e.clear(), this.#t.clear();
    });
  }
  getAll() {
    return Array.from(this.#e);
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => Je(t, r)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => Je(e, t));
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return R.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(L))
      )
    );
  }
};
function ue(e) {
  return e.options.scope?.id;
}
function it(e) {
  return {
    onFetch: (t, r) => {
      const n = t.options, o = t.fetchOptions?.meta?.fetchMore?.direction, i = t.state.data?.pages || [], a = t.state.data?.pageParams || [];
      let u = { pages: [], pageParams: [] }, p = 0;
      const f = async () => {
        let x = !1;
        const h = (g) => {
          Object.defineProperty(g, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? x = !0 : t.signal.addEventListener("abort", () => {
              x = !0;
            }), t.signal)
          });
        }, m = an(t.options, t.fetchOptions), l = async (g, w, E) => {
          if (x)
            return Promise.reject();
          if (w == null && g.pages.length)
            return Promise.resolve(g);
          const j = (() => {
            const k = {
              client: t.client,
              queryKey: t.queryKey,
              pageParam: w,
              direction: E ? "backward" : "forward",
              meta: t.options.meta
            };
            return h(k), k;
          })(), y = await m(j), { maxPages: _ } = t.options, d = E ? cn : un;
          return {
            pages: d(g.pages, y, _),
            pageParams: d(g.pageParams, w, _)
          };
        };
        if (o && i.length) {
          const g = o === "backward", w = g ? yo : at, E = {
            pages: i,
            pageParams: a
          }, $ = w(n, E);
          u = await l(E, $, g);
        } else {
          const g = e ?? i.length;
          do {
            const w = p === 0 ? a[0] ?? n.initialPageParam : at(n, u);
            if (p > 0 && w == null)
              break;
            u = await l(u, w), p++;
          } while (p < g);
        }
        return u;
      };
      t.options.persister ? t.fetchFn = () => t.options.persister?.(
        f,
        {
          client: t.client,
          queryKey: t.queryKey,
          meta: t.options.meta,
          signal: t.signal
        },
        r
      ) : t.fetchFn = f;
    }
  };
}
function at(e, { pages: t, pageParams: r }) {
  const n = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[n],
    t,
    r[n],
    r
  ) : void 0;
}
function yo(e, { pages: t, pageParams: r }) {
  return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, r[0], r) : void 0;
}
var xo = class {
  #e;
  #t;
  #r;
  #o;
  #s;
  #n;
  #i;
  #a;
  constructor(e = {}) {
    this.#e = e.queryCache || new go(), this.#t = e.mutationCache || new vo(), this.#r = e.defaultOptions || {}, this.#o = /* @__PURE__ */ new Map(), this.#s = /* @__PURE__ */ new Map(), this.#n = 0;
  }
  mount() {
    this.#n++, this.#n === 1 && (this.#i = ln.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), this.#e.onFocus());
    }), this.#a = Xe.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), this.#e.onOnline());
    }));
  }
  unmount() {
    this.#n--, this.#n === 0 && (this.#i?.(), this.#i = void 0, this.#a?.(), this.#a = void 0);
  }
  isFetching(e) {
    return this.#e.findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return this.#t.findAll({ ...e, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return this.#e.get(t.queryHash)?.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), r = this.#e.build(this, t), n = r.state.data;
    return n === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && r.isStaleByTime(et(t.staleTime, r)) && this.prefetchQuery(t), Promise.resolve(n));
  }
  getQueriesData(e) {
    return this.#e.findAll(e).map(({ queryKey: t, state: r }) => {
      const n = r.data;
      return [t, n];
    });
  }
  setQueryData(e, t, r) {
    const n = this.defaultQueryOptions({ queryKey: e }), i = this.#e.get(
      n.queryHash
    )?.state.data, a = dn(t, i);
    if (a !== void 0)
      return this.#e.build(this, n).setData(a, { ...r, manual: !0 });
  }
  setQueriesData(e, t, r) {
    return R.batch(
      () => this.#e.findAll(e).map(({ queryKey: n }) => [
        n,
        this.setQueryData(n, t, r)
      ])
    );
  }
  getQueryState(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return this.#e.get(
      t.queryHash
    )?.state;
  }
  removeQueries(e) {
    const t = this.#e;
    R.batch(() => {
      t.findAll(e).forEach((r) => {
        t.remove(r);
      });
    });
  }
  resetQueries(e, t) {
    const r = this.#e;
    return R.batch(() => (r.findAll(e).forEach((n) => {
      n.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...e
      },
      t
    )));
  }
  cancelQueries(e, t = {}) {
    const r = { revert: !0, ...t }, n = R.batch(
      () => this.#e.findAll(e).map((o) => o.cancel(r))
    );
    return Promise.all(n).then(L).catch(L);
  }
  invalidateQueries(e, t = {}) {
    return R.batch(() => (this.#e.findAll(e).forEach((r) => {
      r.invalidate();
    }), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...e,
        type: e?.refetchType ?? e?.type ?? "active"
      },
      t
    )));
  }
  refetchQueries(e, t = {}) {
    const r = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }, n = R.batch(
      () => this.#e.findAll(e).filter((o) => !o.isDisabled() && !o.isStatic()).map((o) => {
        let i = o.fetch(void 0, r);
        return r.throwOnError || (i = i.catch(L)), o.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(n).then(L);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const r = this.#e.build(this, t);
    return r.isStaleByTime(
      et(t.staleTime, r)
    ) ? r.fetch(t) : Promise.resolve(r.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(L).catch(L);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = it(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(L).catch(L);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = it(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return Xe.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#t;
  }
  getDefaultOptions() {
    return this.#r;
  }
  setDefaultOptions(e) {
    this.#r = e;
  }
  setQueryDefaults(e, t) {
    this.#o.set(tt(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...this.#o.values()], r = {};
    return t.forEach((n) => {
      rt(e, n.queryKey) && Object.assign(r, n.defaultOptions);
    }), r;
  }
  setMutationDefaults(e, t) {
    this.#s.set(tt(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...this.#s.values()], r = {};
    return t.forEach((n) => {
      rt(e, n.mutationKey) && Object.assign(r, n.defaultOptions);
    }), r;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...this.#r.queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Ft(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === fn && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e?._defaulted ? e : {
      ...this.#r.mutations,
      ...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.#e.clear(), this.#t.clear();
  }
};
function _o(e) {
  return e;
}
function ct(e, t, r) {
  if (typeof t != "object" || t === null)
    return;
  const n = e.getMutationCache(), o = e.getQueryCache(), i = r?.defaultOptions?.deserializeData ?? e.getDefaultOptions().hydrate?.deserializeData ?? _o, a = t.mutations || [], u = t.queries || [];
  a.forEach(({ state: p, ...f }) => {
    n.build(
      e,
      {
        ...e.getDefaultOptions().hydrate?.mutations,
        ...r?.defaultOptions?.mutations,
        ...f
      },
      p
    );
  }), u.forEach(
    ({ queryKey: p, state: f, queryHash: x, meta: h, promise: m, dehydratedAt: l }) => {
      const g = m ? hn(m) : void 0, w = f.data === void 0 ? g?.data : f.data, E = w === void 0 ? w : i(w);
      let $ = o.get(x);
      const j = $?.state.status === "pending", y = $?.state.fetchStatus === "fetching";
      if ($) {
        const _ = g && // We only need this undefined check to handle older dehydration
        // payloads that might not have dehydratedAt
        l !== void 0 && l > $.state.dataUpdatedAt;
        if (f.dataUpdatedAt > $.state.dataUpdatedAt || _) {
          const { fetchStatus: d, ...k } = f;
          $.setState({
            ...k,
            data: E
          });
        }
      } else
        $ = o.build(
          e,
          {
            ...e.getDefaultOptions().hydrate?.queries,
            ...r?.defaultOptions?.queries,
            queryKey: p,
            queryHash: x,
            meta: h
          },
          // Reset fetch status to idle to avoid
          // query being stuck in fetching state upon hydration
          {
            ...f,
            data: E,
            fetchStatus: "idle",
            status: E !== void 0 ? "success" : f.status
          }
        );
      m && !j && !y && // Only hydrate if dehydration is newer than any existing data,
      // this is always true for new queries
      (l === void 0 || l > $.state.dataUpdatedAt) && $.fetch(void 0, {
        // RSC transformed promises are not thenable
        initialPromise: Promise.resolve(m).then(i)
      });
    }
  );
}
var bo = ({
  children: e,
  options: t = {},
  state: r,
  queryClient: n
}) => {
  const o = qt(n), i = K.useRef(t);
  i.current = t;
  const a = K.useMemo(() => {
    if (r) {
      if (typeof r != "object")
        return;
      const u = o.getQueryCache(), p = r.queries || [], f = [], x = [];
      for (const h of p) {
        const m = u.get(h.queryHash);
        m ? (h.state.dataUpdatedAt > m.state.dataUpdatedAt || h.promise && m.state.status !== "pending" && m.state.fetchStatus !== "fetching" && h.dehydratedAt !== void 0 && h.dehydratedAt > m.state.dataUpdatedAt) && x.push(h) : f.push(h);
      }
      if (f.length > 0 && ct(o, { queries: f }, i.current), x.length > 0)
        return x;
    }
  }, [o, r]);
  return K.useEffect(() => {
    a && ct(o, { queries: a }, i.current);
  }, [o, a]), e;
};
function wo({ error: e }) {
  return /* @__PURE__ */ s.jsx(Bt, { error: e });
}
/**
 * react-router v7.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function jo(e) {
  return /* @__PURE__ */ K.createElement(rn, { flushSync: Mn.flushSync, ...e });
}
const Ze = Fe({ stagger: !1 }), ko = new xo({
  defaultOptions: {
    queries: {
      staleTime: 1e3 * 60 * 5
    }
  }
}), $o = ({
  router: e,
  hydrate: t = !1
}) => /* @__PURE__ */ s.jsx(Wt, { children: /* @__PURE__ */ s.jsx(Ut, { client: ko, children: /* @__PURE__ */ s.jsx(bo, { state: t ? window.DATA : void 0, children: /* @__PURE__ */ s.jsx(At, { value: !1, children: /* @__PURE__ */ s.jsx(It, { children: /* @__PURE__ */ s.jsx(Ze.Provider, { value: { stagger: !t }, children: /* @__PURE__ */ s.jsx(jo, { router: e }) }) }) }) }) }) }), zo = ({
  router: e,
  context: t,
  queryClient: r,
  helmetContext: n,
  bypassProtection: o = !1
}) => /* @__PURE__ */ s.jsx(Wt, { children: /* @__PURE__ */ s.jsx(Ut, { client: r, children: /* @__PURE__ */ s.jsx(It, { context: n, children: /* @__PURE__ */ s.jsx(At, { value: o, children: /* @__PURE__ */ s.jsx(nn, { router: e, context: t }) }) }) }) });
function c(e, t, r) {
  function n(u, p) {
    var f;
    Object.defineProperty(u, "_zod", {
      value: u._zod ?? {},
      enumerable: !1
    }), (f = u._zod).traits ?? (f.traits = /* @__PURE__ */ new Set()), u._zod.traits.add(e), t(u, p);
    for (const x in a.prototype)
      x in u || Object.defineProperty(u, x, { value: a.prototype[x].bind(u) });
    u._zod.constr = a, u._zod.def = p;
  }
  const o = r?.Parent ?? Object;
  class i extends o {
  }
  Object.defineProperty(i, "name", { value: e });
  function a(u) {
    var p;
    const f = r?.Parent ? new i() : this;
    n(f, u), (p = f._zod).deferred ?? (p.deferred = []);
    for (const x of f._zod.deferred)
      x();
    return f;
  }
  return Object.defineProperty(a, "init", { value: n }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (u) => r?.Parent && u instanceof r.Parent ? !0 : u?._zod?.traits?.has(e)
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class se extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
const tr = {};
function V(e) {
  return tr;
}
function Po(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, o]) => t.indexOf(+n) === -1).map(([n, o]) => o);
}
function Eo(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function rr(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ue(e) {
  return e == null;
}
function Le(e) {
  const t = e.startsWith("^") ? 1 : 0, r = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, r);
}
function S(e, t, r) {
  Object.defineProperty(e, t, {
    get() {
      {
        const n = r();
        return e[t] = n, n;
      }
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Qe(e, t, r) {
  Object.defineProperty(e, t, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function re(e) {
  return JSON.stringify(e);
}
const nr = Error.captureStackTrace ? Error.captureStackTrace : (...e) => {
};
function Ce(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const So = rr(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Te(e) {
  if (Ce(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(Ce(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
const Zo = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function _e(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function J(e, t, r) {
  const n = new e._zod.constr(t ?? e._zod.def);
  return (!t || r?.parent) && (n._zod.parent = e), n;
}
function b(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Co(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function To(e, t) {
  const r = {}, n = e._zod.def;
  for (const o in t) {
    if (!(o in n.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && (r[o] = n.shape[o]);
  }
  return J(e, {
    ...e._zod.def,
    shape: r,
    checks: []
  });
}
function No(e, t) {
  const r = { ...e._zod.def.shape }, n = e._zod.def;
  for (const o in t) {
    if (!(o in n.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && delete r[o];
  }
  return J(e, {
    ...e._zod.def,
    shape: r,
    checks: []
  });
}
function Oo(e, t) {
  if (!Te(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = {
    ...e._zod.def,
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return Qe(this, "shape", n), n;
    },
    checks: []
    // delete existing checks
  };
  return J(e, r);
}
function Ao(e, t) {
  return J(e, {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Qe(this, "shape", r), r;
    },
    catchall: t._zod.def.catchall,
    checks: []
    // delete existing checks
  });
}
function Io(e, t, r) {
  const n = t._zod.def.shape, o = { ...n };
  if (r)
    for (const i in r) {
      if (!(i in n))
        throw new Error(`Unrecognized key: "${i}"`);
      r[i] && (o[i] = e ? new e({
        type: "optional",
        innerType: n[i]
      }) : n[i]);
    }
  else
    for (const i in n)
      o[i] = e ? new e({
        type: "optional",
        innerType: n[i]
      }) : n[i];
  return J(t, {
    ...t._zod.def,
    shape: o,
    checks: []
  });
}
function Ro(e, t, r) {
  const n = t._zod.def.shape, o = { ...n };
  if (r)
    for (const i in r) {
      if (!(i in o))
        throw new Error(`Unrecognized key: "${i}"`);
      r[i] && (o[i] = new e({
        type: "nonoptional",
        innerType: n[i]
      }));
    }
  else
    for (const i in n)
      o[i] = new e({
        type: "nonoptional",
        innerType: n[i]
      });
  return J(t, {
    ...t._zod.def,
    shape: o,
    // optional: [],
    checks: []
  });
}
function ne(e, t = 0) {
  for (let r = t; r < e.issues.length; r++)
    if (e.issues[r]?.continue !== !0)
      return !0;
  return !1;
}
function Be(e, t) {
  return t.map((r) => {
    var n;
    return (n = r).path ?? (n.path = []), r.path.unshift(e), r;
  });
}
function le(e) {
  return typeof e == "string" ? e : e?.message;
}
function Y(e, t, r) {
  const n = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const o = le(e.inst?._zod.def?.error?.(e)) ?? le(t?.error?.(e)) ?? le(r.customError?.(e)) ?? le(r.localeError?.(e)) ?? "Invalid input";
    n.message = o;
  }
  return delete n.inst, delete n.continue, t?.reportInput || delete n.input, n;
}
function Ke(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function ie(...e) {
  const [t, r, n] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: r,
    inst: n
  } : { ...t };
}
const or = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), Object.defineProperty(e, "message", {
    get() {
      return JSON.stringify(t, Eo, 2);
    },
    enumerable: !0
    // configurable: false,
  });
}, sr = c("$ZodError", or), ir = c("$ZodError", or, { Parent: Error });
function Do(e, t = (r) => r.message) {
  const r = {}, n = [];
  for (const o of e.issues)
    o.path.length > 0 ? (r[o.path[0]] = r[o.path[0]] || [], r[o.path[0]].push(t(o))) : n.push(t(o));
  return { formErrors: n, fieldErrors: r };
}
function Mo(e, t) {
  const r = t || function(i) {
    return i.message;
  }, n = { _errors: [] }, o = (i) => {
    for (const a of i.issues)
      if (a.code === "invalid_union" && a.errors.length)
        a.errors.map((u) => o({ issues: u }));
      else if (a.code === "invalid_key")
        o({ issues: a.issues });
      else if (a.code === "invalid_element")
        o({ issues: a.issues });
      else if (a.path.length === 0)
        n._errors.push(r(a));
      else {
        let u = n, p = 0;
        for (; p < a.path.length; ) {
          const f = a.path[p];
          p === a.path.length - 1 ? (u[f] = u[f] || { _errors: [] }, u[f]._errors.push(r(a))) : u[f] = u[f] || { _errors: [] }, u = u[f], p++;
        }
      }
  };
  return o(e), n;
}
const Fo = (e) => (t, r, n, o) => {
  const i = n ? Object.assign(n, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: r, issues: [] }, i);
  if (a instanceof Promise)
    throw new se();
  if (a.issues.length) {
    const u = new (o?.Err ?? e)(a.issues.map((p) => Y(p, i, V())));
    throw nr(u, o?.callee), u;
  }
  return a.value;
}, qo = (e) => async (t, r, n, o) => {
  const i = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: r, issues: [] }, i);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const u = new (o?.Err ?? e)(a.issues.map((p) => Y(p, i, V())));
    throw nr(u, o?.callee), u;
  }
  return a.value;
}, ar = (e) => (t, r, n) => {
  const o = n ? { ...n, async: !1 } : { async: !1 }, i = t._zod.run({ value: r, issues: [] }, o);
  if (i instanceof Promise)
    throw new se();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? sr)(i.issues.map((a) => Y(a, o, V())))
  } : { success: !0, data: i.value };
}, Uo = /* @__PURE__ */ ar(ir), cr = (e) => async (t, r, n) => {
  const o = n ? Object.assign(n, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: r, issues: [] }, o);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((a) => Y(a, o, V())))
  } : { success: !0, data: i.value };
}, Lo = /* @__PURE__ */ cr(ir), Qo = /^[cC][^\s-]{8,}$/, Bo = /^[0-9a-z]+$/, Ko = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Ho = /^[0-9a-vA-V]{20}$/, Wo = /^[A-Za-z0-9]{27}$/, Vo = /^[a-zA-Z0-9_-]{21}$/, Yo = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Go = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, ut = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/, Jo = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Xo = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function es() {
  return new RegExp(Xo, "u");
}
const ts = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rs = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, ns = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, os = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ss = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ur = /^[A-Za-z0-9_-]*$/, is = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/, as = /^\+(?:[0-9]){6,14}[0-9]$/, lr = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", cs = /* @__PURE__ */ new RegExp(`^${lr}$`);
function dr(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function us(e) {
  return new RegExp(`^${dr(e)}$`);
}
function ls(e) {
  const t = dr({ precision: e.precision }), r = ["Z"];
  e.local && r.push(""), e.offset && r.push("([+-]\\d{2}:\\d{2})");
  const n = `${t}(?:${r.join("|")})`;
  return new RegExp(`^${lr}T(?:${n})$`);
}
const ds = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, fs = /^[^A-Z]*$/, hs = /^[^a-z]*$/, U = /* @__PURE__ */ c("$ZodCheck", (e, t) => {
  var r;
  e._zod ?? (e._zod = {}), e._zod.def = t, (r = e._zod).onattach ?? (r.onattach = []);
}), ps = /* @__PURE__ */ c("$ZodCheckMaxLength", (e, t) => {
  U.init(e, t), e._zod.when = (r) => {
    const n = r.value;
    return !Ue(n) && n.length !== void 0;
  }, e._zod.onattach.push((r) => {
    const n = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const n = r.value;
    if (n.length <= t.maximum)
      return;
    const i = Ke(n);
    r.issues.push({
      origin: i,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), ms = /* @__PURE__ */ c("$ZodCheckMinLength", (e, t) => {
  U.init(e, t), e._zod.when = (r) => {
    const n = r.value;
    return !Ue(n) && n.length !== void 0;
  }, e._zod.onattach.push((r) => {
    const n = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const n = r.value;
    if (n.length >= t.minimum)
      return;
    const i = Ke(n);
    r.issues.push({
      origin: i,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), gs = /* @__PURE__ */ c("$ZodCheckLengthEquals", (e, t) => {
  U.init(e, t), e._zod.when = (r) => {
    const n = r.value;
    return !Ue(n) && n.length !== void 0;
  }, e._zod.onattach.push((r) => {
    const n = r._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (r) => {
    const n = r.value, o = n.length;
    if (o === t.length)
      return;
    const i = Ke(n), a = o > t.length;
    r.issues.push({
      origin: i,
      ...a ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), be = /* @__PURE__ */ c("$ZodCheckStringFormat", (e, t) => {
  var r, n;
  U.init(e, t), e._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (r = e._zod).check ?? (r.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (n = e._zod).check ?? (n.check = () => {
  });
}), vs = /* @__PURE__ */ c("$ZodCheckRegex", (e, t) => {
  be.init(e, t), e._zod.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), ys = /* @__PURE__ */ c("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = fs), be.init(e, t);
}), xs = /* @__PURE__ */ c("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = hs), be.init(e, t);
}), _s = /* @__PURE__ */ c("$ZodCheckIncludes", (e, t) => {
  U.init(e, t);
  const r = _e(t.includes), n = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${r}` : r);
  t.pattern = n, e._zod.onattach.push((o) => {
    const i = o._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), bs = /* @__PURE__ */ c("$ZodCheckStartsWith", (e, t) => {
  U.init(e, t);
  const r = new RegExp(`^${_e(t.prefix)}.*`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.startsWith(t.prefix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ws = /* @__PURE__ */ c("$ZodCheckEndsWith", (e, t) => {
  U.init(e, t);
  const r = new RegExp(`.*${_e(t.suffix)}$`);
  t.pattern ?? (t.pattern = r), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (n) => {
    n.value.endsWith(t.suffix) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), js = /* @__PURE__ */ c("$ZodCheckOverwrite", (e, t) => {
  U.init(e, t), e._zod.check = (r) => {
    r.value = t.tx(r.value);
  };
});
class ks {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((a) => a), o = Math.min(...n.map((a) => a.length - a.trimStart().length)), i = n.map((a) => a.slice(o)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of i)
      this.content.push(a);
  }
  compile() {
    const t = Function, r = this?.args, o = [...(this?.content ?? [""]).map((i) => `  ${i}`)];
    return new t(...r, o.join(`
`));
  }
}
const $s = {
  major: 4,
  minor: 0,
  patch: 0
}, T = /* @__PURE__ */ c("$ZodType", (e, t) => {
  var r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = $s;
  const n = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && n.unshift(e);
  for (const o of n)
    for (const i of o._zod.onattach)
      i(e);
  if (n.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (i, a, u) => {
      let p = ne(i), f;
      for (const x of a) {
        if (x._zod.when) {
          if (!x._zod.when(i))
            continue;
        } else if (p)
          continue;
        const h = i.issues.length, m = x._zod.check(i);
        if (m instanceof Promise && u?.async === !1)
          throw new se();
        if (f || m instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await m, i.issues.length !== h && (p || (p = ne(i, h)));
          });
        else {
          if (i.issues.length === h)
            continue;
          p || (p = ne(i, h));
        }
      }
      return f ? f.then(() => i) : i;
    };
    e._zod.run = (i, a) => {
      const u = e._zod.parse(i, a);
      if (u instanceof Promise) {
        if (a.async === !1)
          throw new se();
        return u.then((p) => o(p, n, a));
      }
      return o(u, n, a);
    };
  }
  e["~standard"] = {
    validate: (o) => {
      try {
        const i = Uo(e, o);
        return i.success ? { value: i.data } : { issues: i.error?.issues };
      } catch {
        return Lo(e, o).then((a) => a.success ? { value: a.data } : { issues: a.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), He = /* @__PURE__ */ c("$ZodString", (e, t) => {
  T.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? ds(e._zod.bag), e._zod.parse = (r, n) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Z = /* @__PURE__ */ c("$ZodStringFormat", (e, t) => {
  be.init(e, t), He.init(e, t);
}), zs = /* @__PURE__ */ c("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Go), Z.init(e, t);
}), Ps = /* @__PURE__ */ c("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = ut(n));
  } else
    t.pattern ?? (t.pattern = ut());
  Z.init(e, t);
}), Es = /* @__PURE__ */ c("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Jo), Z.init(e, t);
}), Ss = /* @__PURE__ */ c("$ZodURL", (e, t) => {
  Z.init(e, t), e._zod.check = (r) => {
    try {
      const n = r.value, o = new URL(n), i = o.href;
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(o.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: is.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: r.value,
        inst: e,
        continue: !t.abort
      })), !n.endsWith("/") && i.endsWith("/") ? r.value = i.slice(0, -1) : r.value = i;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Zs = /* @__PURE__ */ c("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = es()), Z.init(e, t);
}), Cs = /* @__PURE__ */ c("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Vo), Z.init(e, t);
}), Ts = /* @__PURE__ */ c("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Qo), Z.init(e, t);
}), Ns = /* @__PURE__ */ c("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Bo), Z.init(e, t);
}), Os = /* @__PURE__ */ c("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Ko), Z.init(e, t);
}), As = /* @__PURE__ */ c("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Ho), Z.init(e, t);
}), Is = /* @__PURE__ */ c("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Wo), Z.init(e, t);
}), Rs = /* @__PURE__ */ c("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = ls(t)), Z.init(e, t);
}), Ds = /* @__PURE__ */ c("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = cs), Z.init(e, t);
}), Ms = /* @__PURE__ */ c("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = us(t)), Z.init(e, t);
}), Fs = /* @__PURE__ */ c("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Yo), Z.init(e, t);
}), qs = /* @__PURE__ */ c("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ts), Z.init(e, t), e._zod.onattach.push((r) => {
    const n = r._zod.bag;
    n.format = "ipv4";
  });
}), Us = /* @__PURE__ */ c("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = rs), Z.init(e, t), e._zod.onattach.push((r) => {
    const n = r._zod.bag;
    n.format = "ipv6";
  }), e._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Ls = /* @__PURE__ */ c("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = ns), Z.init(e, t);
}), Qs = /* @__PURE__ */ c("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = os), Z.init(e, t), e._zod.check = (r) => {
    const [n, o] = r.value.split("/");
    try {
      if (!o)
        throw new Error();
      const i = Number(o);
      if (`${i}` !== o)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function fr(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Bs = /* @__PURE__ */ c("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = ss), Z.init(e, t), e._zod.onattach.push((r) => {
    r._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (r) => {
    fr(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Ks(e) {
  if (!ur.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (n) => n === "-" ? "+" : "/"), r = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return fr(r);
}
const Hs = /* @__PURE__ */ c("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ur), Z.init(e, t), e._zod.onattach.push((r) => {
    r._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (r) => {
    Ks(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ws = /* @__PURE__ */ c("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = as), Z.init(e, t);
});
function Vs(e, t = null) {
  try {
    const r = e.split(".");
    if (r.length !== 3)
      return !1;
    const [n] = r;
    if (!n)
      return !1;
    const o = JSON.parse(atob(n));
    return !("typ" in o && o?.typ !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const Ys = /* @__PURE__ */ c("$ZodJWT", (e, t) => {
  Z.init(e, t), e._zod.check = (r) => {
    Vs(r.value, t.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Gs = /* @__PURE__ */ c("$ZodUnknown", (e, t) => {
  T.init(e, t), e._zod.parse = (r) => r;
}), Js = /* @__PURE__ */ c("$ZodNever", (e, t) => {
  T.init(e, t), e._zod.parse = (r, n) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: e
  }), r);
});
function lt(e, t, r) {
  e.issues.length && t.issues.push(...Be(r, e.issues)), t.value[r] = e.value;
}
const Xs = /* @__PURE__ */ c("$ZodArray", (e, t) => {
  T.init(e, t), e._zod.parse = (r, n) => {
    const o = r.value;
    if (!Array.isArray(o))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), r;
    r.value = Array(o.length);
    const i = [];
    for (let a = 0; a < o.length; a++) {
      const u = o[a], p = t.element._zod.run({
        value: u,
        issues: []
      }, n);
      p instanceof Promise ? i.push(p.then((f) => lt(f, r, a))) : lt(p, r, a);
    }
    return i.length ? Promise.all(i).then(() => r) : r;
  };
});
function de(e, t, r) {
  e.issues.length && t.issues.push(...Be(r, e.issues)), t.value[r] = e.value;
}
function dt(e, t, r, n) {
  e.issues.length ? n[r] === void 0 ? r in n ? t.value[r] = void 0 : t.value[r] = e.value : t.issues.push(...Be(r, e.issues)) : e.value === void 0 ? r in n && (t.value[r] = void 0) : t.value[r] = e.value;
}
const ei = /* @__PURE__ */ c("$ZodObject", (e, t) => {
  T.init(e, t);
  const r = rr(() => {
    const h = Object.keys(t.shape);
    for (const l of h)
      if (!(t.shape[l] instanceof T))
        throw new Error(`Invalid element at key "${l}": expected a Zod schema`);
    const m = Co(t.shape);
    return {
      shape: t.shape,
      keys: h,
      keySet: new Set(h),
      numKeys: h.length,
      optionalKeys: new Set(m)
    };
  });
  S(e._zod, "propValues", () => {
    const h = t.shape, m = {};
    for (const l in h) {
      const g = h[l]._zod;
      if (g.values) {
        m[l] ?? (m[l] = /* @__PURE__ */ new Set());
        for (const w of g.values)
          m[l].add(w);
      }
    }
    return m;
  });
  const n = (h) => {
    const m = new ks(["shape", "payload", "ctx"]), l = r.value, g = (j) => {
      const y = re(j);
      return `shape[${y}]._zod.run({ value: input[${y}], issues: [] }, ctx)`;
    };
    m.write("const input = payload.value;");
    const w = /* @__PURE__ */ Object.create(null);
    let E = 0;
    for (const j of l.keys)
      w[j] = `key_${E++}`;
    m.write("const newResult = {}");
    for (const j of l.keys)
      if (l.optionalKeys.has(j)) {
        const y = w[j];
        m.write(`const ${y} = ${g(j)};`);
        const _ = re(j);
        m.write(`
        if (${y}.issues.length) {
          if (input[${_}] === undefined) {
            if (${_} in input) {
              newResult[${_}] = undefined;
            }
          } else {
            payload.issues = payload.issues.concat(
              ${y}.issues.map((iss) => ({
                ...iss,
                path: iss.path ? [${_}, ...iss.path] : [${_}],
              }))
            );
          }
        } else if (${y}.value === undefined) {
          if (${_} in input) newResult[${_}] = undefined;
        } else {
          newResult[${_}] = ${y}.value;
        }
        `);
      } else {
        const y = w[j];
        m.write(`const ${y} = ${g(j)};`), m.write(`
          if (${y}.issues.length) payload.issues = payload.issues.concat(${y}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${re(j)}, ...iss.path] : [${re(j)}]
          })));`), m.write(`newResult[${re(j)}] = ${y}.value`);
      }
    m.write("payload.value = newResult;"), m.write("return payload;");
    const $ = m.compile();
    return (j, y) => $(h, j, y);
  };
  let o;
  const i = Ce, a = !tr.jitless, p = a && So.value, f = t.catchall;
  let x;
  e._zod.parse = (h, m) => {
    x ?? (x = r.value);
    const l = h.value;
    if (!i(l))
      return h.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), h;
    const g = [];
    if (a && p && m?.async === !1 && m.jitless !== !0)
      o || (o = n(t.shape)), h = o(h, m);
    else {
      h.value = {};
      const y = x.shape;
      for (const _ of x.keys) {
        const d = y[_], k = d._zod.run({ value: l[_], issues: [] }, m), I = d._zod.optin === "optional" && d._zod.optout === "optional";
        k instanceof Promise ? g.push(k.then((D) => I ? dt(D, h, _, l) : de(D, h, _))) : I ? dt(k, h, _, l) : de(k, h, _);
      }
    }
    if (!f)
      return g.length ? Promise.all(g).then(() => h) : h;
    const w = [], E = x.keySet, $ = f._zod, j = $.def.type;
    for (const y of Object.keys(l)) {
      if (E.has(y))
        continue;
      if (j === "never") {
        w.push(y);
        continue;
      }
      const _ = $.run({ value: l[y], issues: [] }, m);
      _ instanceof Promise ? g.push(_.then((d) => de(d, h, y))) : de(_, h, y);
    }
    return w.length && h.issues.push({
      code: "unrecognized_keys",
      keys: w,
      input: l,
      inst: e
    }), g.length ? Promise.all(g).then(() => h) : h;
  };
});
function ft(e, t, r, n) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  return t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: r,
    errors: e.map((o) => o.issues.map((i) => Y(i, n, V())))
  }), t;
}
const ti = /* @__PURE__ */ c("$ZodUnion", (e, t) => {
  T.init(e, t), S(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), S(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), S(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), S(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((n) => n._zod.pattern);
      return new RegExp(`^(${r.map((n) => Le(n.source)).join("|")})$`);
    }
  }), e._zod.parse = (r, n) => {
    let o = !1;
    const i = [];
    for (const a of t.options) {
      const u = a._zod.run({
        value: r.value,
        issues: []
      }, n);
      if (u instanceof Promise)
        i.push(u), o = !0;
      else {
        if (u.issues.length === 0)
          return u;
        i.push(u);
      }
    }
    return o ? Promise.all(i).then((a) => ft(a, r, e, n)) : ft(i, r, e, n);
  };
}), ri = /* @__PURE__ */ c("$ZodIntersection", (e, t) => {
  T.init(e, t), e._zod.parse = (r, n) => {
    const o = r.value, i = t.left._zod.run({ value: o, issues: [] }, n), a = t.right._zod.run({ value: o, issues: [] }, n);
    return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([p, f]) => ht(r, p, f)) : ht(r, i, a);
  };
});
function Ne(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Te(e) && Te(t)) {
    const r = Object.keys(t), n = Object.keys(e).filter((i) => r.indexOf(i) !== -1), o = { ...e, ...t };
    for (const i of n) {
      const a = Ne(e[i], t[i]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...a.mergeErrorPath]
        };
      o[i] = a.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n], i = t[n], a = Ne(o, i);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [n, ...a.mergeErrorPath]
        };
      r.push(a.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function ht(e, t, r) {
  if (t.issues.length && e.issues.push(...t.issues), r.issues.length && e.issues.push(...r.issues), ne(e))
    return e;
  const n = Ne(t.value, r.value);
  if (!n.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(n.mergeErrorPath)}`);
  return e.value = n.data, e;
}
const ni = /* @__PURE__ */ c("$ZodEnum", (e, t) => {
  T.init(e, t);
  const r = Po(t.entries);
  e._zod.values = new Set(r), e._zod.pattern = new RegExp(`^(${r.filter((n) => Zo.has(typeof n)).map((n) => typeof n == "string" ? _e(n) : n.toString()).join("|")})$`), e._zod.parse = (n, o) => {
    const i = n.value;
    return e._zod.values.has(i) || n.issues.push({
      code: "invalid_value",
      values: r,
      input: i,
      inst: e
    }), n;
  };
}), oi = /* @__PURE__ */ c("$ZodTransform", (e, t) => {
  T.init(e, t), e._zod.parse = (r, n) => {
    const o = t.transform(r.value, r);
    if (n.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (r.value = a, r));
    if (o instanceof Promise)
      throw new se();
    return r.value = o, r;
  };
}), si = /* @__PURE__ */ c("$ZodOptional", (e, t) => {
  T.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", S(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), S(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Le(r.source)})?$`) : void 0;
  }), e._zod.parse = (r, n) => t.innerType._zod.optin === "optional" ? t.innerType._zod.run(r, n) : r.value === void 0 ? r : t.innerType._zod.run(r, n);
}), ii = /* @__PURE__ */ c("$ZodNullable", (e, t) => {
  T.init(e, t), S(e._zod, "optin", () => t.innerType._zod.optin), S(e._zod, "optout", () => t.innerType._zod.optout), S(e._zod, "pattern", () => {
    const r = t.innerType._zod.pattern;
    return r ? new RegExp(`^(${Le(r.source)}|null)$`) : void 0;
  }), S(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (r, n) => r.value === null ? r : t.innerType._zod.run(r, n);
}), ai = /* @__PURE__ */ c("$ZodDefault", (e, t) => {
  T.init(e, t), e._zod.optin = "optional", S(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    if (r.value === void 0)
      return r.value = t.defaultValue, r;
    const o = t.innerType._zod.run(r, n);
    return o instanceof Promise ? o.then((i) => pt(i, t)) : pt(o, t);
  };
});
function pt(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const ci = /* @__PURE__ */ c("$ZodPrefault", (e, t) => {
  T.init(e, t), e._zod.optin = "optional", S(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => (r.value === void 0 && (r.value = t.defaultValue), t.innerType._zod.run(r, n));
}), ui = /* @__PURE__ */ c("$ZodNonOptional", (e, t) => {
  T.init(e, t), S(e._zod, "values", () => {
    const r = t.innerType._zod.values;
    return r ? new Set([...r].filter((n) => n !== void 0)) : void 0;
  }), e._zod.parse = (r, n) => {
    const o = t.innerType._zod.run(r, n);
    return o instanceof Promise ? o.then((i) => mt(i, e)) : mt(o, e);
  };
});
function mt(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const li = /* @__PURE__ */ c("$ZodCatch", (e, t) => {
  T.init(e, t), e._zod.optin = "optional", S(e._zod, "optout", () => t.innerType._zod.optout), S(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (r, n) => {
    const o = t.innerType._zod.run(r, n);
    return o instanceof Promise ? o.then((i) => (r.value = i.value, i.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: i.issues.map((a) => Y(a, n, V()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = o.value, o.issues.length && (r.value = t.catchValue({
      ...r,
      error: {
        issues: o.issues.map((i) => Y(i, n, V()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), di = /* @__PURE__ */ c("$ZodPipe", (e, t) => {
  T.init(e, t), S(e._zod, "values", () => t.in._zod.values), S(e._zod, "optin", () => t.in._zod.optin), S(e._zod, "optout", () => t.out._zod.optout), e._zod.parse = (r, n) => {
    const o = t.in._zod.run(r, n);
    return o instanceof Promise ? o.then((i) => gt(i, t, n)) : gt(o, t, n);
  };
});
function gt(e, t, r) {
  return ne(e) ? e : t.out._zod.run({ value: e.value, issues: e.issues }, r);
}
const fi = /* @__PURE__ */ c("$ZodReadonly", (e, t) => {
  T.init(e, t), S(e._zod, "propValues", () => t.innerType._zod.propValues), S(e._zod, "values", () => t.innerType._zod.values), S(e._zod, "optin", () => t.innerType._zod.optin), S(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (r, n) => {
    const o = t.innerType._zod.run(r, n);
    return o instanceof Promise ? o.then(vt) : vt(o);
  };
});
function vt(e) {
  return e.value = Object.freeze(e.value), e;
}
const hi = /* @__PURE__ */ c("$ZodCustom", (e, t) => {
  U.init(e, t), T.init(e, t), e._zod.parse = (r, n) => r, e._zod.check = (r) => {
    const n = r.value, o = t.fn(n);
    if (o instanceof Promise)
      return o.then((i) => yt(i, r, n, e));
    yt(o, r, n, e);
  };
});
function yt(e, t, r, n) {
  if (!e) {
    const o = {
      code: "custom",
      input: r,
      inst: n,
      // incorporates params.error into issue reporting
      path: [...n._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !n._zod.def.abort
      // params: inst._zod.def.params,
    };
    n._zod.def.params && (o.params = n._zod.def.params), t.issues.push(ie(o));
  }
}
class pi {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...r) {
    const n = r[0];
    if (this._map.set(t, n), n && typeof n == "object" && "id" in n) {
      if (this._idmap.has(n.id))
        throw new Error(`ID ${n.id} already exists in the registry`);
      this._idmap.set(n.id, t);
    }
    return this;
  }
  remove(t) {
    return this._map.delete(t), this;
  }
  get(t) {
    const r = t._zod.parent;
    if (r) {
      const n = { ...this.get(r) ?? {} };
      return delete n.id, { ...n, ...this._map.get(t) };
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function mi() {
  return new pi();
}
const fe = /* @__PURE__ */ mi();
function gi(e, t) {
  return new e({
    type: "string",
    ...b(t)
  });
}
function vi(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function xt(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function yi(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function xi(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...b(t)
  });
}
function _i(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...b(t)
  });
}
function bi(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...b(t)
  });
}
function wi(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function ji(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function ki(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function $i(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function zi(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Pi(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ei(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Si(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Zi(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ci(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ti(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ni(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Oi(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ai(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ii(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Ri(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...b(t)
  });
}
function Di(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...b(t)
  });
}
function Mi(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...b(t)
  });
}
function Fi(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...b(t)
  });
}
function qi(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...b(t)
  });
}
function Ui(e) {
  return new e({
    type: "unknown"
  });
}
function Li(e, t) {
  return new e({
    type: "never",
    ...b(t)
  });
}
function hr(e, t) {
  return new ps({
    check: "max_length",
    ...b(t),
    maximum: e
  });
}
function ve(e, t) {
  return new ms({
    check: "min_length",
    ...b(t),
    minimum: e
  });
}
function pr(e, t) {
  return new gs({
    check: "length_equals",
    ...b(t),
    length: e
  });
}
function Qi(e, t) {
  return new vs({
    check: "string_format",
    format: "regex",
    ...b(t),
    pattern: e
  });
}
function Bi(e) {
  return new ys({
    check: "string_format",
    format: "lowercase",
    ...b(e)
  });
}
function Ki(e) {
  return new xs({
    check: "string_format",
    format: "uppercase",
    ...b(e)
  });
}
function Hi(e, t) {
  return new _s({
    check: "string_format",
    format: "includes",
    ...b(t),
    includes: e
  });
}
function Wi(e, t) {
  return new bs({
    check: "string_format",
    format: "starts_with",
    ...b(t),
    prefix: e
  });
}
function Vi(e, t) {
  return new ws({
    check: "string_format",
    format: "ends_with",
    ...b(t),
    suffix: e
  });
}
function ae(e) {
  return new js({
    check: "overwrite",
    tx: e
  });
}
function Yi(e) {
  return ae((t) => t.normalize(e));
}
function Gi() {
  return ae((e) => e.trim());
}
function Ji() {
  return ae((e) => e.toLowerCase());
}
function Xi() {
  return ae((e) => e.toUpperCase());
}
function ea(e, t, r) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...b(r)
  });
}
function ta(e, t, r) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...b(r)
  });
}
const ra = /* @__PURE__ */ c("ZodISODateTime", (e, t) => {
  Rs.init(e, t), C.init(e, t);
});
function na(e) {
  return Di(ra, e);
}
const oa = /* @__PURE__ */ c("ZodISODate", (e, t) => {
  Ds.init(e, t), C.init(e, t);
});
function sa(e) {
  return Mi(oa, e);
}
const ia = /* @__PURE__ */ c("ZodISOTime", (e, t) => {
  Ms.init(e, t), C.init(e, t);
});
function aa(e) {
  return Fi(ia, e);
}
const ca = /* @__PURE__ */ c("ZodISODuration", (e, t) => {
  Fs.init(e, t), C.init(e, t);
});
function ua(e) {
  return qi(ca, e);
}
const la = (e, t) => {
  sr.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (r) => Mo(e, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => Do(e, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => e.issues.push(r)
      // enumerable: false,
    },
    addIssues: {
      value: (r) => e.issues.push(...r)
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, we = c("ZodError", la, {
  Parent: Error
}), da = /* @__PURE__ */ Fo(we), fa = /* @__PURE__ */ qo(we), ha = /* @__PURE__ */ ar(we), pa = /* @__PURE__ */ cr(we), N = /* @__PURE__ */ c("ZodType", (e, t) => (T.init(e, t), e.def = t, Object.defineProperty(e, "_def", { value: t }), e.check = (...r) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...r.map((n) => typeof n == "function" ? { _zod: { check: n, def: { check: "custom" }, onattach: [] } } : n)
    ]
  }
  // { parent: true }
), e.clone = (r, n) => J(e, r, n), e.brand = () => e, e.register = (r, n) => (r.add(e, n), e), e.parse = (r, n) => da(e, r, n, { callee: e.parse }), e.safeParse = (r, n) => ha(e, r, n), e.parseAsync = async (r, n) => fa(e, r, n, { callee: e.parseAsync }), e.safeParseAsync = async (r, n) => pa(e, r, n), e.spa = e.safeParseAsync, e.refine = (r, n) => e.check(sc(r, n)), e.superRefine = (r) => e.check(ic(r)), e.overwrite = (r) => e.check(ae(r)), e.optional = () => jt(e), e.nullable = () => kt(e), e.nullish = () => jt(kt(e)), e.nonoptional = (r) => Ga(e, r), e.array = () => Ra(e), e.or = (r) => qa([e, r]), e.and = (r) => La(e, r), e.transform = (r) => $t(e, Ba(r)), e.default = (r) => Wa(e, r), e.prefault = (r) => Ya(e, r), e.catch = (r) => Xa(e, r), e.pipe = (r) => $t(e, r), e.readonly = () => rc(e), e.describe = (r) => {
  const n = e.clone();
  return fe.add(n, { description: r }), n;
}, Object.defineProperty(e, "description", {
  get() {
    return fe.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...r) => {
  if (r.length === 0)
    return fe.get(e);
  const n = e.clone();
  return fe.add(n, r[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), mr = /* @__PURE__ */ c("_ZodString", (e, t) => {
  He.init(e, t), N.init(e, t);
  const r = e._zod.bag;
  e.format = r.format ?? null, e.minLength = r.minimum ?? null, e.maxLength = r.maximum ?? null, e.regex = (...n) => e.check(Qi(...n)), e.includes = (...n) => e.check(Hi(...n)), e.startsWith = (...n) => e.check(Wi(...n)), e.endsWith = (...n) => e.check(Vi(...n)), e.min = (...n) => e.check(ve(...n)), e.max = (...n) => e.check(hr(...n)), e.length = (...n) => e.check(pr(...n)), e.nonempty = (...n) => e.check(ve(1, ...n)), e.lowercase = (n) => e.check(Bi(n)), e.uppercase = (n) => e.check(Ki(n)), e.trim = () => e.check(Gi()), e.normalize = (...n) => e.check(Yi(...n)), e.toLowerCase = () => e.check(Ji()), e.toUpperCase = () => e.check(Xi());
}), ma = /* @__PURE__ */ c("ZodString", (e, t) => {
  He.init(e, t), mr.init(e, t), e.email = (r) => e.check(vi(ga, r)), e.url = (r) => e.check(wi(va, r)), e.jwt = (r) => e.check(Ri(Ta, r)), e.emoji = (r) => e.check(ji(ya, r)), e.guid = (r) => e.check(xt(bt, r)), e.uuid = (r) => e.check(yi(he, r)), e.uuidv4 = (r) => e.check(xi(he, r)), e.uuidv6 = (r) => e.check(_i(he, r)), e.uuidv7 = (r) => e.check(bi(he, r)), e.nanoid = (r) => e.check(ki(xa, r)), e.guid = (r) => e.check(xt(bt, r)), e.cuid = (r) => e.check($i(_a, r)), e.cuid2 = (r) => e.check(zi(ba, r)), e.ulid = (r) => e.check(Pi(wa, r)), e.base64 = (r) => e.check(Oi(Sa, r)), e.base64url = (r) => e.check(Ai(Za, r)), e.xid = (r) => e.check(Ei(ja, r)), e.ksuid = (r) => e.check(Si(ka, r)), e.ipv4 = (r) => e.check(Zi($a, r)), e.ipv6 = (r) => e.check(Ci(za, r)), e.cidrv4 = (r) => e.check(Ti(Pa, r)), e.cidrv6 = (r) => e.check(Ni(Ea, r)), e.e164 = (r) => e.check(Ii(Ca, r)), e.datetime = (r) => e.check(na(r)), e.date = (r) => e.check(sa(r)), e.time = (r) => e.check(aa(r)), e.duration = (r) => e.check(ua(r));
});
function _t(e) {
  return gi(ma, e);
}
const C = /* @__PURE__ */ c("ZodStringFormat", (e, t) => {
  Z.init(e, t), mr.init(e, t);
}), ga = /* @__PURE__ */ c("ZodEmail", (e, t) => {
  Es.init(e, t), C.init(e, t);
}), bt = /* @__PURE__ */ c("ZodGUID", (e, t) => {
  zs.init(e, t), C.init(e, t);
}), he = /* @__PURE__ */ c("ZodUUID", (e, t) => {
  Ps.init(e, t), C.init(e, t);
}), va = /* @__PURE__ */ c("ZodURL", (e, t) => {
  Ss.init(e, t), C.init(e, t);
}), ya = /* @__PURE__ */ c("ZodEmoji", (e, t) => {
  Zs.init(e, t), C.init(e, t);
}), xa = /* @__PURE__ */ c("ZodNanoID", (e, t) => {
  Cs.init(e, t), C.init(e, t);
}), _a = /* @__PURE__ */ c("ZodCUID", (e, t) => {
  Ts.init(e, t), C.init(e, t);
}), ba = /* @__PURE__ */ c("ZodCUID2", (e, t) => {
  Ns.init(e, t), C.init(e, t);
}), wa = /* @__PURE__ */ c("ZodULID", (e, t) => {
  Os.init(e, t), C.init(e, t);
}), ja = /* @__PURE__ */ c("ZodXID", (e, t) => {
  As.init(e, t), C.init(e, t);
}), ka = /* @__PURE__ */ c("ZodKSUID", (e, t) => {
  Is.init(e, t), C.init(e, t);
}), $a = /* @__PURE__ */ c("ZodIPv4", (e, t) => {
  qs.init(e, t), C.init(e, t);
}), za = /* @__PURE__ */ c("ZodIPv6", (e, t) => {
  Us.init(e, t), C.init(e, t);
}), Pa = /* @__PURE__ */ c("ZodCIDRv4", (e, t) => {
  Ls.init(e, t), C.init(e, t);
}), Ea = /* @__PURE__ */ c("ZodCIDRv6", (e, t) => {
  Qs.init(e, t), C.init(e, t);
}), Sa = /* @__PURE__ */ c("ZodBase64", (e, t) => {
  Bs.init(e, t), C.init(e, t);
}), Za = /* @__PURE__ */ c("ZodBase64URL", (e, t) => {
  Hs.init(e, t), C.init(e, t);
}), Ca = /* @__PURE__ */ c("ZodE164", (e, t) => {
  Ws.init(e, t), C.init(e, t);
}), Ta = /* @__PURE__ */ c("ZodJWT", (e, t) => {
  Ys.init(e, t), C.init(e, t);
}), Na = /* @__PURE__ */ c("ZodUnknown", (e, t) => {
  Gs.init(e, t), N.init(e, t);
});
function wt() {
  return Ui(Na);
}
const Oa = /* @__PURE__ */ c("ZodNever", (e, t) => {
  Js.init(e, t), N.init(e, t);
});
function Aa(e) {
  return Li(Oa, e);
}
const Ia = /* @__PURE__ */ c("ZodArray", (e, t) => {
  Xs.init(e, t), N.init(e, t), e.element = t.element, e.min = (r, n) => e.check(ve(r, n)), e.nonempty = (r) => e.check(ve(1, r)), e.max = (r, n) => e.check(hr(r, n)), e.length = (r, n) => e.check(pr(r, n)), e.unwrap = () => e.element;
});
function Ra(e, t) {
  return ea(Ia, e, t);
}
const Da = /* @__PURE__ */ c("ZodObject", (e, t) => {
  ei.init(e, t), N.init(e, t), S(e, "shape", () => t.shape), e.keyof = () => gr(Object.keys(e._zod.def.shape)), e.catchall = (r) => e.clone({ ...e._zod.def, catchall: r }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: wt() }), e.loose = () => e.clone({ ...e._zod.def, catchall: wt() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Aa() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (r) => Oo(e, r), e.merge = (r) => Ao(e, r), e.pick = (r) => To(e, r), e.omit = (r) => No(e, r), e.partial = (...r) => Io(vr, e, r[0]), e.required = (...r) => Ro(yr, e, r[0]);
});
function Ma(e, t) {
  const r = {
    type: "object",
    get shape() {
      return Qe(this, "shape", { ...e }), this.shape;
    },
    ...b(t)
  };
  return new Da(r);
}
const Fa = /* @__PURE__ */ c("ZodUnion", (e, t) => {
  ti.init(e, t), N.init(e, t), e.options = t.options;
});
function qa(e, t) {
  return new Fa({
    type: "union",
    options: e,
    ...b(t)
  });
}
const Ua = /* @__PURE__ */ c("ZodIntersection", (e, t) => {
  ri.init(e, t), N.init(e, t);
});
function La(e, t) {
  return new Ua({
    type: "intersection",
    left: e,
    right: t
  });
}
const Oe = /* @__PURE__ */ c("ZodEnum", (e, t) => {
  ni.init(e, t), N.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const r = new Set(Object.keys(t.entries));
  e.extract = (n, o) => {
    const i = {};
    for (const a of n)
      if (r.has(a))
        i[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Oe({
      ...t,
      checks: [],
      ...b(o),
      entries: i
    });
  }, e.exclude = (n, o) => {
    const i = { ...t.entries };
    for (const a of n)
      if (r.has(a))
        delete i[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Oe({
      ...t,
      checks: [],
      ...b(o),
      entries: i
    });
  };
});
function gr(e, t) {
  const r = Array.isArray(e) ? Object.fromEntries(e.map((n) => [n, n])) : e;
  return new Oe({
    type: "enum",
    entries: r,
    ...b(t)
  });
}
const Qa = /* @__PURE__ */ c("ZodTransform", (e, t) => {
  oi.init(e, t), N.init(e, t), e._zod.parse = (r, n) => {
    r.addIssue = (i) => {
      if (typeof i == "string")
        r.issues.push(ie(i, r.value, t));
      else {
        const a = i;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = r.value), a.inst ?? (a.inst = e), a.continue ?? (a.continue = !0), r.issues.push(ie(a));
      }
    };
    const o = t.transform(r.value, r);
    return o instanceof Promise ? o.then((i) => (r.value = i, r)) : (r.value = o, r);
  };
});
function Ba(e) {
  return new Qa({
    type: "transform",
    transform: e
  });
}
const vr = /* @__PURE__ */ c("ZodOptional", (e, t) => {
  si.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function jt(e) {
  return new vr({
    type: "optional",
    innerType: e
  });
}
const Ka = /* @__PURE__ */ c("ZodNullable", (e, t) => {
  ii.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function kt(e) {
  return new Ka({
    type: "nullable",
    innerType: e
  });
}
const Ha = /* @__PURE__ */ c("ZodDefault", (e, t) => {
  ai.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Wa(e, t) {
  return new Ha({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const Va = /* @__PURE__ */ c("ZodPrefault", (e, t) => {
  ci.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ya(e, t) {
  return new Va({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const yr = /* @__PURE__ */ c("ZodNonOptional", (e, t) => {
  ui.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ga(e, t) {
  return new yr({
    type: "nonoptional",
    innerType: e,
    ...b(t)
  });
}
const Ja = /* @__PURE__ */ c("ZodCatch", (e, t) => {
  li.init(e, t), N.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Xa(e, t) {
  return new Ja({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ec = /* @__PURE__ */ c("ZodPipe", (e, t) => {
  di.init(e, t), N.init(e, t), e.in = t.in, e.out = t.out;
});
function $t(e, t) {
  return new ec({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const tc = /* @__PURE__ */ c("ZodReadonly", (e, t) => {
  fi.init(e, t), N.init(e, t);
});
function rc(e) {
  return new tc({
    type: "readonly",
    innerType: e
  });
}
const nc = /* @__PURE__ */ c("ZodCustom", (e, t) => {
  hi.init(e, t), N.init(e, t);
});
function oc(e, t) {
  const r = new U({
    check: "custom",
    ...b(t)
  });
  return r._zod.check = e, r;
}
function sc(e, t = {}) {
  return ta(nc, e, t);
}
function ic(e, t) {
  const r = oc((n) => (n.addIssue = (o) => {
    if (typeof o == "string")
      n.issues.push(ie(o, n.value, r._zod.def));
    else {
      const i = o;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = r), i.continue ?? (i.continue = !r._zod.def.abort), n.issues.push(ie(i));
    }
  }, e(n.value, n)), t);
  return r;
}
const ac = Ma({
  buildId: _t(),
  timestamp: _t(),
  status: gr(["in-progress", "success", "failed"])
}), cc = ({
  buildId: e,
  endpoint: t = "/__zuplo/docs"
}) => {
  const r = pn({
    queryKey: ["zuplo-build-check", e, t],
    refetchInterval: 3e3,
    enabled: typeof e < "u" && !1,
    retry: !1,
    queryFn: () => fetch(t, { signal: AbortSignal.timeout(2e3) }).then((o) => {
      if (!o.ok) throw new Error("Failed to fetch build status");
      return o.json();
    }).then((o) => ac.parse(o))
  });
  if (r.isError || !r.data || r.data.buildId === e)
    return null;
  const n = r.data.status === "success";
  return /* @__PURE__ */ s.jsxs("div", { className: "fixed flex flex-col gap-3 p-4 rounded-xl w-96 border z-20 bg-background left-0 right-0 top-4 mx-auto shadow-lg", children: [
    n ? /* @__PURE__ */ s.jsxs("div", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ s.jsx(Fn, { size: 16 }),
      /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "New version available" })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ s.jsx(qn, { size: 16, className: "animate-spin" }),
      /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "Building new version..." })
    ] }),
    /* @__PURE__ */ s.jsx("span", { className: "text-xs", children: n ? "To see the new version, reload the page now." : "A new version of the developer portal will be available soon." }),
    /* @__PURE__ */ s.jsx(
      Ht,
      {
        variant: "outline",
        size: "sm",
        className: "w-full",
        onClick: () => {
          window.location.reload();
        },
        children: "Reload"
      }
    )
  ] });
}, uc = () => {
  const e = xe(), t = H(e.pathname);
  F(() => {
    const r = t.current !== e.pathname, n = e.hash !== "";
    r && !n && window.scrollTo(0, 0), t.current = e.pathname;
  }, [e.pathname, e.hash]);
}, lc = ({
  icon: e
}) => typeof e == "string" ? /* @__PURE__ */ s.jsx(
  "img",
  {
    src: `https://cdn.simpleicons.org/${e}/000000/ffffff`,
    className: "size-5",
    alt: e
  }
) : e, dc = (e) => /^https?:/.test(e), fc = () => {
  const { site: e } = eu(), t = e?.footer;
  return t ? /* @__PURE__ */ s.jsx("footer", { className: "border-t bg-background", children: /* @__PURE__ */ s.jsxs("div", { className: "mx-auto max-w-screen-2xl px-4 lg:px-8 py-8 pt-20", children: [
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: O("flex flex-row gap-8", {
          "justify-center": !t.position || t.position === "center",
          "justify-start": t.position === "start",
          "justify-end": t.position === "end"
        }),
        children: [
          /* @__PURE__ */ s.jsx(A.Target, { name: "footer-before" }),
          t.columns && /* @__PURE__ */ s.jsx(
            "div",
            {
              className: "w-full md:max-w-screen-md grid grid-cols-[1fr_1fr] gap-8 md:grid-cols-[repeat(var(--columns),minmax(0,1fr))]",
              style: { "--columns": t.columns.length },
              children: t.columns.map((r) => /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: O({
                    "justify-self-center": !r.position || r.position === "center",
                    "justify-self-start": r.position === "start",
                    "justify-self-end": r.position === "end"
                  }),
                  children: [
                    /* @__PURE__ */ s.jsx("span", { className: "text-sm font-semibold", children: r.title }),
                    /* @__PURE__ */ s.jsx("ul", { className: "mt-4 space-y-2", children: r.links.map((n) => {
                      const o = "flex flex-row gap-1 items-center text-sm text-muted-foreground hover:text-accent-foreground";
                      return /* @__PURE__ */ s.jsx("li", { children: dc(n.href) ? /* @__PURE__ */ s.jsxs(
                        "a",
                        {
                          href: n.href,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          className: o,
                          children: [
                            /* @__PURE__ */ s.jsx("span", { children: n.label }),
                            /* @__PURE__ */ s.jsx(Un, { size: 12 })
                          ]
                        }
                      ) : /* @__PURE__ */ s.jsx(jn, { to: n.href, className: o, children: /* @__PURE__ */ s.jsx("span", { children: n.label }) }) }, n.href + n.label);
                    }) })
                  ]
                },
                r.title
              ))
            }
          ),
          /* @__PURE__ */ s.jsx(A.Target, { name: "footer-after" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: O(
          "flex items-center justify-between",
          t.columns && "border-t mt-8 pt-8"
        ),
        children: [
          t.logo && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              "img",
              {
                src: t.logo.src.light,
                alt: t.logo.alt,
                className: "w-8 dark:hidden",
                style: { width: t.logo.width }
              }
            ),
            /* @__PURE__ */ s.jsx(
              "img",
              {
                src: t.logo.src.dark,
                alt: t.logo.alt,
                className: "w-8 hidden dark:block",
                style: { width: t.logo.width }
              }
            )
          ] }),
          t.copyright && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-muted-foreground", children: t.copyright }),
          /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-2", children: t.social?.map((r) => /* @__PURE__ */ s.jsxs(
            "a",
            {
              href: r.href,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "w-auto gap-2 flex text-muted-foreground hover:text-accent-foreground",
              children: [
                /* @__PURE__ */ s.jsx(lc, { icon: r.icon }),
                r.label
              ]
            },
            r.href
          )) })
        ]
      }
    )
  ] }) }) : null;
};
function Ae({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: O("animate-pulse rounded-md bg-muted", e),
      ...t
    }
  );
}
const zt = {
  info: "bg-blue-500",
  note: "bg-gray-500",
  tip: "bg-green-600",
  caution: "bg-orange-500",
  danger: "bg-rose-500"
}, hc = () => {
  const { site: e } = M(), [t, r] = G(!0);
  if (!e?.banner || !t)
    return /* @__PURE__ */ s.jsx("style", { children: ":root { --banner-height: 0px; }" });
  const n = e.banner.color && e.banner.color in zt ? zt[e.banner.color] : e.banner.color ? void 0 : "bg-primary", o = n ? {} : { backgroundColor: e.banner.color };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: O(
        "relative text-primary-foreground text-sm font-medium px-4 py-2 flex gap-2 items-center lg:h-(--banner-height)",
        n
      ),
      style: o,
      children: [
        /* @__PURE__ */ s.jsx("div", { className: "w-full", children: e.banner.message }),
        e.banner.dismissible && /* @__PURE__ */ s.jsx(
          "button",
          {
            type: "button",
            className: "md:absolute md:end-4 -m-1.5 p-1.5 hover:bg-accent-foreground/10 rounded-md",
            onClick: () => r(!1),
            children: /* @__PURE__ */ s.jsx(Ln, { size: 16 })
          }
        )
      ]
    }
  );
}, xr = (e) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 100",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M80.092 2.963A4.66 4.66 0 0 1 84.449 0h34.049c6.325 0 10.835 6.135 8.948 12.172L116.653 46.71a4.688 4.688 0 0 1-4.474 3.29H75c-5.178 0-7.813 4.687-9.375 9.374-1.288 3.864-11.07 28.963-14.467 37.662A4.66 4.66 0 0 1 46.801 100H12.75c-6.324 0-10.834-6.134-8.947-12.171l10.793-34.54A4.688 4.688 0 0 1 19.071 50H56.25c5.178 0 7.813-4.687 9.375-9.375 1.288-3.864 11.07-28.962 14.467-37.662Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M83.54 57.813a7.813 7.813 0 0 0-7.316 5.07L63.888 95.777c-.766 2.043.744 4.222 2.926 4.222h36.828c5.211 0 9.875-3.232 11.704-8.11l8.821-23.522c1.915-5.107-1.861-10.555-7.315-10.555H83.539ZM29.17 0a12.5 12.5 0 0 0-11.704 8.111l-8.82 23.521c-1.915 5.107 1.86 10.556 7.315 10.556h33.312a7.813 7.813 0 0 0 7.316-5.07L68.924 4.223C69.691 2.18 68.18 0 65.998 0H29.17Z"
        }
      )
    ]
  }
);
xr.displayName = "ZudokuLogo";
const _r = ({ className: e }) => /* @__PURE__ */ s.jsxs(
  "a",
  {
    href: "https://zudoku.dev",
    target: "_blank",
    rel: "noopener noreferrer",
    className: O(
      "flex justify-between items-center w-full border border-transparent hover:border-border rounded-full hover:shadow-xs h-7 px-3 text-nowrap hover:bg-muted/80 transition-all",
      e
    ),
    children: [
      /* @__PURE__ */ s.jsxs("div", { className: "opacity-70 hover:opacity-100 transition-opacity gap-1.5 text-[11px] font-medium rounded-full h-7 flex items-center text-nowrap", children: [
        /* @__PURE__ */ s.jsx(xr, { className: "w-3.5 h-3.5 dark:fill-white" }),
        "powered by ",
        "Zudoku"
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "text-xs font-medium opacity-70 hover:text-foreground transition-colors cursor-pointer", children: /* @__PURE__ */ s.jsx(
        Qn,
        {
          size: 12,
          absoluteStrokeWidth: !0,
          strokeWidth: 1.5,
          className: "rtl:rotate-180"
        }
      ) })
    ]
  }
);
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ye.apply(null, arguments);
}
var pe = { exports: {} }, z = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pt;
function pc() {
  if (Pt) return z;
  Pt = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, x = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, l = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, j = e ? Symbol.for("react.scope") : 60119;
  function y(d) {
    if (typeof d == "object" && d !== null) {
      var k = d.$$typeof;
      switch (k) {
        case t:
          switch (d = d.type, d) {
            case p:
            case f:
            case n:
            case i:
            case o:
            case h:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case u:
                case x:
                case g:
                case l:
                case a:
                  return d;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  function _(d) {
    return y(d) === f;
  }
  return z.AsyncMode = p, z.ConcurrentMode = f, z.ContextConsumer = u, z.ContextProvider = a, z.Element = t, z.ForwardRef = x, z.Fragment = n, z.Lazy = g, z.Memo = l, z.Portal = r, z.Profiler = i, z.StrictMode = o, z.Suspense = h, z.isAsyncMode = function(d) {
    return _(d) || y(d) === p;
  }, z.isConcurrentMode = _, z.isContextConsumer = function(d) {
    return y(d) === u;
  }, z.isContextProvider = function(d) {
    return y(d) === a;
  }, z.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === t;
  }, z.isForwardRef = function(d) {
    return y(d) === x;
  }, z.isFragment = function(d) {
    return y(d) === n;
  }, z.isLazy = function(d) {
    return y(d) === g;
  }, z.isMemo = function(d) {
    return y(d) === l;
  }, z.isPortal = function(d) {
    return y(d) === r;
  }, z.isProfiler = function(d) {
    return y(d) === i;
  }, z.isStrictMode = function(d) {
    return y(d) === o;
  }, z.isSuspense = function(d) {
    return y(d) === h;
  }, z.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === n || d === f || d === i || d === o || d === h || d === m || typeof d == "object" && d !== null && (d.$$typeof === g || d.$$typeof === l || d.$$typeof === a || d.$$typeof === u || d.$$typeof === x || d.$$typeof === E || d.$$typeof === $ || d.$$typeof === j || d.$$typeof === w);
  }, z.typeOf = y, z;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Et;
function mc() {
  return Et || (Et = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, x = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, l = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, E = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, j = e ? Symbol.for("react.scope") : 60119;
    function y(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === n || v === f || v === i || v === o || v === h || v === m || typeof v == "object" && v !== null && (v.$$typeof === g || v.$$typeof === l || v.$$typeof === a || v.$$typeof === u || v.$$typeof === x || v.$$typeof === E || v.$$typeof === $ || v.$$typeof === j || v.$$typeof === w);
    }
    function _(v) {
      if (typeof v == "object" && v !== null) {
        var ke = v.$$typeof;
        switch (ke) {
          case t:
            var ce = v.type;
            switch (ce) {
              case p:
              case f:
              case n:
              case i:
              case o:
              case h:
                return ce;
              default:
                var Ye = ce && ce.$$typeof;
                switch (Ye) {
                  case u:
                  case x:
                  case g:
                  case l:
                  case a:
                    return Ye;
                  default:
                    return ke;
                }
            }
          case r:
            return ke;
        }
      }
    }
    var d = p, k = f, I = u, D = a, X = t, Q = x, je = n, W = g, Ar = l, Ir = r, Rr = i, Dr = o, Mr = h, We = !1;
    function Fr(v) {
      return We || (We = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Ve(v) || _(v) === p;
    }
    function Ve(v) {
      return _(v) === f;
    }
    function qr(v) {
      return _(v) === u;
    }
    function Ur(v) {
      return _(v) === a;
    }
    function Lr(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function Qr(v) {
      return _(v) === x;
    }
    function Br(v) {
      return _(v) === n;
    }
    function Kr(v) {
      return _(v) === g;
    }
    function Hr(v) {
      return _(v) === l;
    }
    function Wr(v) {
      return _(v) === r;
    }
    function Vr(v) {
      return _(v) === i;
    }
    function Yr(v) {
      return _(v) === o;
    }
    function Gr(v) {
      return _(v) === h;
    }
    P.AsyncMode = d, P.ConcurrentMode = k, P.ContextConsumer = I, P.ContextProvider = D, P.Element = X, P.ForwardRef = Q, P.Fragment = je, P.Lazy = W, P.Memo = Ar, P.Portal = Ir, P.Profiler = Rr, P.StrictMode = Dr, P.Suspense = Mr, P.isAsyncMode = Fr, P.isConcurrentMode = Ve, P.isContextConsumer = qr, P.isContextProvider = Ur, P.isElement = Lr, P.isForwardRef = Qr, P.isFragment = Br, P.isLazy = Kr, P.isMemo = Hr, P.isPortal = Wr, P.isProfiler = Vr, P.isStrictMode = Yr, P.isSuspense = Gr, P.isValidElementType = y, P.typeOf = _;
  }()), P;
}
var St;
function gc() {
  return St || (St = 1, process.env.NODE_ENV === "production" ? pe.exports = pc() : pe.exports = mc()), pe.exports;
}
var Pe, Zt;
function vc() {
  if (Zt) return Pe;
  Zt = 1;
  var e = gc(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = n, i[e.Memo] = o;
  function a(g) {
    return e.isMemo(g) ? o : i[g.$$typeof] || t;
  }
  var u = Object.defineProperty, p = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, x = Object.getOwnPropertyDescriptor, h = Object.getPrototypeOf, m = Object.prototype;
  function l(g, w, E) {
    if (typeof w != "string") {
      if (m) {
        var $ = h(w);
        $ && $ !== m && l(g, $, E);
      }
      var j = p(w);
      f && (j = j.concat(f(w)));
      for (var y = a(g), _ = a(w), d = 0; d < j.length; ++d) {
        var k = j[d];
        if (!r[k] && !(E && E[k]) && !(_ && _[k]) && !(y && y[k])) {
          var I = x(w, k);
          try {
            u(g, k, I);
          } catch {
          }
        }
      }
    }
    return g;
  }
  return Pe = l, Pe;
}
vc();
var br = function(t, r, n) {
  return t = t <= n ? t : n, t = t >= r ? t : r, t;
}, yc = function() {
  var t = !1, r = [], n = function() {
    t = !0;
    var u = r.shift();
    if (u)
      return u(n);
    t = !1;
  }, o = function() {
    t = !1, r = [];
  }, i = function(u) {
    r.push(u), !t && r.length === 1 && n();
  };
  return {
    clear: o,
    enqueue: i
  };
}, xc = function() {
  var t, r = function() {
    t && window.cancelAnimationFrame(t);
  }, n = function(i, a) {
    var u, p, f = function(h) {
      if (p = p || h, u = h - p, u > a) {
        i();
        return;
      }
      t = window.requestAnimationFrame(f);
    };
    t = window.requestAnimationFrame(f);
  };
  return {
    cancel: r,
    schedule: n
  };
}, _c = function(t) {
  var r = 0;
  return t >= 0 && t < 0.2 ? r = 0.1 : t >= 0.2 && t < 0.5 ? r = 0.04 : t >= 0.5 && t < 0.8 ? r = 0.02 : t >= 0.8 && t < 0.99 && (r = 5e-3), br(t + r, 0, 0.994);
}, Ct = function(t) {
  F(t, []);
}, bc = function(t) {
  return ++t % 1e6;
}, wc = function() {
  var t = G(0), r = t[1];
  return B(function() {
    return r(bc);
  }, []);
}, jc = function(t) {
  t === void 0 && (t = {});
  var r = wc(), n = H(ye({}, t)), o = B(function() {
    return n.current;
  }, []), i = B(function(a) {
    a && (Object.assign(n.current, a), r());
  }, []);
  return [o, i];
}, kc = function() {
  var t = H(!0);
  return t.current ? (t.current = !1, !0) : t.current;
}, Tt = function(t, r) {
  var n = kc();
  F(function() {
    if (!n)
      return t();
  }, r);
}, wr = function() {
}, Nt = {
  isFinished: !0,
  progress: 0,
  sideEffect: wr
}, $c = function(t) {
  var r = t === void 0 ? {} : t, n = r.animationDuration, o = n === void 0 ? 200 : n, i = r.incrementDuration, a = i === void 0 ? 800 : i, u = r.isAnimating, p = u === void 0 ? !1 : u, f = r.minimum, x = f === void 0 ? 0.08 : f, h = jc(Nt), m = h[0], l = h[1], g = H(null), w = H(null);
  Ct(function() {
    g.current = yc(), w.current = xc();
  });
  var E = B(function() {
    var k, I;
    (k = w.current) == null || k.cancel(), (I = g.current) == null || I.clear();
  }, []), $ = B(function(k) {
    var I;
    if (k = br(k, x, 1), k === 1) {
      var D, X;
      E(), (D = g.current) == null || D.enqueue(function(Q) {
        l({
          progress: k,
          sideEffect: function() {
            var W;
            return (W = w.current) == null ? void 0 : W.schedule(Q, o);
          }
        });
      }), (X = g.current) == null || X.enqueue(function() {
        l({
          isFinished: !0,
          sideEffect: E
        });
      });
      return;
    }
    (I = g.current) == null || I.enqueue(function(Q) {
      l({
        isFinished: !1,
        progress: k,
        sideEffect: function() {
          var W;
          return (W = w.current) == null ? void 0 : W.schedule(Q, o);
        }
      });
    });
  }, [o, E, x, g, l, w]), j = B(function() {
    $(_c(m().progress));
  }, [m, $]), y = B(function() {
    var k = function() {
      var D;
      j(), (D = g.current) == null || D.enqueue(function(X) {
        var Q;
        (Q = w.current) == null || Q.schedule(function() {
          k(), X();
        }, a);
      });
    };
    k();
  }, [a, g, w, j]), _ = H(wr), d = m().sideEffect;
  return F(function() {
    _.current = j;
  }), Ct(function() {
    return p && y(), E;
  }), Tt(function() {
    m().sideEffect();
  }, [m, d]), Tt(function() {
    p ? l(ye({}, Nt, {
      sideEffect: y
    })) : $(1);
  }, [p, $, l, y]), {
    animationDuration: o,
    isFinished: m().isFinished,
    progress: m().progress
  };
};
const jr = () => {
  const t = De().state === "loading", [r, n] = G(!1);
  F(() => {
    const a = setTimeout(() => n(t), 200);
    return () => clearTimeout(a);
  }, [t]);
  const { isFinished: o, progress: i } = $c({ isAnimating: r });
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: "absolute w-0 left-0 right-0 bottom-[-1px] h-[2px] bg-primary transition-all duration-300 ease-in-out",
      style: {
        opacity: o ? 0 : 1,
        width: o ? 0 : `${i * 100}%`
      }
    }
  );
};
function zc() {
  const e = navigator.userAgent.toLowerCase();
  if (e.includes("win")) return "Windows";
  if (e.includes("mac")) return "macOS";
  if (e.includes("linux")) return "Linux";
}
const kr = ({ className: e }) => {
  const t = M(), [r, n] = G(!1), o = B(() => n(!1), []);
  F(() => {
    if (r)
      return;
    function a(u) {
      u.key === "k" && (u.metaKey || u.ctrlKey) && (u.preventDefault(), n(!0));
    }
    return window.addEventListener("keydown", a), () => {
      window.removeEventListener("keydown", a);
    };
  }, [r, n]);
  const i = t.plugins.find(Yn);
  return i ? /* @__PURE__ */ s.jsxs("div", { className: e, children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        onClick: () => n(!0),
        className: "flex items-center border border-input hover:bg-accent hover:text-accent-foreground p-4 relative h-8 justify-start rounded-lg bg-background text-sm text-muted-foreground shadow-none w-full sm:w-72",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 grow", children: [
            /* @__PURE__ */ s.jsx(Bn, { size: 14 }),
            "Search"
          ] }),
          /* @__PURE__ */ s.jsx(te, { children: /* @__PURE__ */ s.jsx(Pc, {}) })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(qe, { fallback: null, children: i.renderSearch({
      isOpen: r,
      onClose: o
    }) })
  ] }) : null;
}, Pc = () => {
  const e = zc();
  return /* @__PURE__ */ s.jsxs("kbd", { className: "absolute end-1.5 hidden h-5 select-none items-center gap-1 rounded-sm border bg-muted px-1.5 font-mono text-[11px] font-medium opacity-100 sm:flex", children: [
    e === "macOS" ? "⌘" : "Ctrl",
    "+K"
  ] });
}, $r = () => {
  const { resolvedTheme: e, setTheme: t } = Rt();
  return /* @__PURE__ */ s.jsx(te, { fallback: /* @__PURE__ */ s.jsx(Se, { variant: "ghost", size: "icon" }), children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      type: "button",
      className: "flex rounded-full border p-0.5 gap-0.5 group",
      onClick: () => t(e === "dark" ? "light" : "dark"),
      "aria-label": e === "dark" ? "Switch to light mode" : "Switch to dark mode",
      children: [
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: O(
              "border border-transparent rounded-full p-0.5 [&>svg>circle]:transition-colors [&>svg>path]:transition-transform transition-all [&>svg>path]:duration-200 [&>svg>circle]:duration-500 [&>svg>circle]:fill-transparent",
              e === "light" && "border-border bg-muted",
              e === "dark" && "group-hover:[&>svg>path]:scale-110 group-hover:[&>svg>path]:-translate-x-[1px] group-hover:[&>svg>path]:-translate-y-[1px] group-hover:rotate-[15deg] "
            ),
            children: /* @__PURE__ */ s.jsx(Kn, { size: 16 })
          }
        ),
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: O(
              "border border-transparent rounded-full p-0.5 transition-transform transform-gpu duration-500",
              e === "dark" && "border-border bg-muted [&>svg>path]:fill-white [&>svg>path]:stroke-transparent",
              e === "light" && "group-hover:rotate-[-10deg] [&>svg>path]:stroke-currentColor"
            ),
            children: /* @__PURE__ */ s.jsx(Hn, { size: 16 })
          }
        )
      ]
    }
  ) });
}, Ec = () => {
  const { navigation: e } = M(), { isAuthenticated: t } = oe(), r = e.filter(Lt(t));
  return r.length === 0 ? /* @__PURE__ */ s.jsx("style", { children: ":root { --top-nav-height: 0px; }" }) : /* @__PURE__ */ s.jsx(qe, { children: /* @__PURE__ */ s.jsxs("div", { className: "items-center justify-between px-8 h-(--top-nav-height) hidden lg:flex text-sm relative", children: [
    /* @__PURE__ */ s.jsx("nav", { className: "text-sm", children: /* @__PURE__ */ s.jsx("ul", { className: "flex flex-row items-center gap-8", children: r.map((n) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(Pr, { ...n }) }, n.label + n.type)) }) }),
    /* @__PURE__ */ s.jsx(A.Target, { name: "top-navigation-side" })
  ] }) });
}, zr = (e) => {
  switch (e.type) {
    case "doc":
      return ee(e.path);
    case "link":
      return e.to;
    case "category":
      return e.link?.path ? ee(e.link.path) : mn(e, (t) => {
        if (t.type !== "category")
          return zr(t);
      }) ?? "";
    case "custom-page":
      return e.path;
  }
}, Ie = ({
  isActive: e,
  children: t,
  ...r
}) => /* @__PURE__ */ s.jsx(
  on,
  {
    viewTransition: !0,
    className: ({ isActive: n, isPending: o }) => {
      const i = n || e;
      return mo(
        "flex items-center gap-2 lg:py-3.5 font-medium -mb-px transition duration-150 delay-75 relative",
        i || o ? [
          "text-foreground",
          // underline with view transition animation
          "after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0",
          "after:h-0.5 after:bg-primary",
          i && "after:[view-transition-name:top-nav-underline]",
          o && "after:bg-primary/25"
        ] : "text-foreground/75 hover:text-foreground"
      );
    },
    ...r,
    children: t
  }
), Pr = (e) => {
  const t = Qt(), r = kn(t.topNavItem, e), n = zr(e);
  return (
    // We don't use isActive here because it has to be inside the navigation,
    // the top nav id doesn't necessarily start with the navigation id
    /* @__PURE__ */ s.jsxs(Ie, { to: n, isActive: r, children: [
      e.icon && /* @__PURE__ */ s.jsx(e.icon, { size: 16, className: "align-[-0.125em]" }),
      e.label
    ] })
  );
}, Sc = () => {
  const { navigation: e, options: t, getProfileMenuItems: r } = M(), { isAuthenticated: n, profile: o, isAuthEnabled: i, login: a } = oe(), [u, p] = G(!1), f = r(), x = e.filter(Lt(n));
  return /* @__PURE__ */ s.jsxs(
    ho,
    {
      direction: t.site?.dir === "rtl" ? "left" : "right",
      open: u,
      onOpenChange: (h) => p(h),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex lg:hidden justify-self-end", children: [
          /* @__PURE__ */ s.jsx(po, { className: "lg:hidden", children: /* @__PURE__ */ s.jsx(Wn, { size: 22 }) }),
          /* @__PURE__ */ s.jsx(jr, {})
        ] }),
        /* @__PURE__ */ s.jsx(
          Xt,
          {
            className: "lg:hidden h-[100dvh] end-0 start-auto w-[320px] rounded-none",
            "aria-describedby": void 0,
            children: /* @__PURE__ */ s.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none h-full flex flex-col justify-between", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx(Jt, { children: /* @__PURE__ */ s.jsx(er, { children: "Navigation" }) }),
                /* @__PURE__ */ s.jsx(kr, { className: "flex p-4" }),
                /* @__PURE__ */ s.jsxs("ul", { className: "flex flex-col items-center gap-4 p-4", children: [
                  /* @__PURE__ */ s.jsx("li", { className: "empty:hidden", children: /* @__PURE__ */ s.jsx(A.Target, { name: "top-navigation-side" }) }),
                  i && /* @__PURE__ */ s.jsx(
                    te,
                    {
                      fallback: /* @__PURE__ */ s.jsx(Ae, { className: "rounded-sm h-5 w-24 mr-4" }),
                      children: n ? Object.values(r()).length > 0 && /* @__PURE__ */ s.jsx(In, { children: /* @__PURE__ */ s.jsxs("li", { children: [
                        o?.name ? `${o.name}` : "My Account",
                        o?.email && /* @__PURE__ */ s.jsx("div", { className: "font-normal text-muted-foreground", children: o.email })
                      ] }) }) : /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
                        Ie,
                        {
                          to: "/signin",
                          onClick: () => p(!1),
                          children: "Login"
                        }
                      ) })
                    }
                  ),
                  x.map((h) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx("button", { type: "button", onClick: () => p(!1), children: /* @__PURE__ */ s.jsx(Pr, { ...h }) }) }, h.label)),
                  i && n && f.length > 0 && /* @__PURE__ */ s.jsx(
                    te,
                    {
                      fallback: /* @__PURE__ */ s.jsx(Ae, { className: "rounded-sm h-5 w-24 mr-4" }),
                      children: f.map((h) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
                        Ie,
                        {
                          to: h.path ?? "",
                          onClick: () => p(!1),
                          children: h.label
                        }
                      ) }, h.label))
                    }
                  ),
                  /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx($r, {}) })
                ] })
              ] }),
              t.site?.showPoweredBy !== !1 && /* @__PURE__ */ s.jsx(_r, { className: "grow-0 justify-center gap-1" })
            ] })
          }
        )
      ]
    }
  );
}, ge = ({ item: e }) => e.children ? /* @__PURE__ */ s.jsxs(ao, { children: [
  /* @__PURE__ */ s.jsx(co, { children: e.label }),
  /* @__PURE__ */ s.jsx(uo, { children: /* @__PURE__ */ s.jsx(lo, { children: e.children.map((t, r) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ s.jsx(ge, { item: t }, r)
  )) }) })
] }, e.label) : /* @__PURE__ */ s.jsx(Me, { to: e.path ?? "", children: /* @__PURE__ */ s.jsxs(fo, { className: "flex gap-2", children: [
  e.icon && /* @__PURE__ */ s.jsx(e.icon, { size: 16, strokeWidth: 1, absoluteStrokeWidth: !0 }),
  e.label
] }, e.label) }), Er = Vt(function() {
  const t = oe(), { isAuthenticated: r, profile: n, isAuthEnabled: o } = oe(), i = M(), { site: a, plugins: u, options: p } = i, f = u.filter((l) => Gt(l)).flatMap((l) => l.getProfileMenuItems(i)).sort((l) => l.weight ?? 0), x = a?.logo ? /https?:\/\//.test(a.logo.src.light) ? a.logo.src.light : ee(p.basePath, a.logo.src.light) : void 0, h = a?.logo ? /https?:\/\//.test(a.logo.src.dark) ? a.logo.src.dark : ee(p.basePath, a.logo.src.dark) : void 0, m = "inset-shadow-[0_-1px_0_0_var(--border)]";
  return /* @__PURE__ */ s.jsxs(
    "header",
    {
      className: "sticky lg:top-0 z-10 bg-background/80 backdrop-blur w-full",
      "data-pagefind-ignore": "all",
      children: [
        /* @__PURE__ */ s.jsx(hc, {}),
        /* @__PURE__ */ s.jsxs("div", { className: O(m, "relative"), children: [
          /* @__PURE__ */ s.jsx(jr, {}),
          /* @__PURE__ */ s.jsxs("div", { className: "max-w-screen-2xl mx-auto flex items-center justify-between h-(--top-header-height) px-4 lg:px-8 border-transparent", children: [
            /* @__PURE__ */ s.jsx("div", { className: "flex", children: /* @__PURE__ */ s.jsx(Me, { to: a?.logo?.href ?? "/", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3.5", children: [
              a?.logo && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                /* @__PURE__ */ s.jsx(
                  "img",
                  {
                    src: x,
                    alt: a.logo.alt ?? a.title,
                    style: { width: a.logo.width },
                    className: "max-h-(--top-header-height) dark:hidden",
                    loading: "lazy"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "img",
                  {
                    src: h,
                    alt: a.logo.alt ?? a.title,
                    style: { width: a.logo.width },
                    className: "max-h-(--top-header-height) hidden dark:block",
                    loading: "lazy"
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsx("span", { className: "font-semibold text-2xl", children: a?.title })
            ] }) }) }),
            /* @__PURE__ */ s.jsx("div", { className: "absolute inset-x-0 justify-center items-center hidden lg:flex w-full pointer-events-none", children: /* @__PURE__ */ s.jsx(kr, { className: "pointer-events-auto" }) }),
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-8", children: [
              /* @__PURE__ */ s.jsx(Sc, {}),
              /* @__PURE__ */ s.jsxs("div", { className: "hidden lg:flex items-center justify-self-end text-sm gap-2", children: [
                /* @__PURE__ */ s.jsx(A.Target, { name: "head-navigation-start" }),
                o && /* @__PURE__ */ s.jsx(
                  te,
                  {
                    fallback: /* @__PURE__ */ s.jsx(Ae, { className: "rounded-sm h-5 w-24 mr-4" }),
                    children: r ? Object.values(f).length > 0 && /* @__PURE__ */ s.jsxs(no, { modal: !1, children: [
                      /* @__PURE__ */ s.jsx(oo, { asChild: !0, children: /* @__PURE__ */ s.jsx(Se, { variant: "ghost", children: n?.name ?? "My Account" }) }),
                      /* @__PURE__ */ s.jsxs(so, { className: "w-56", children: [
                        /* @__PURE__ */ s.jsxs(io, { children: [
                          n?.name ? `${n.name}` : "My Account",
                          n?.email && /* @__PURE__ */ s.jsx("div", { className: "font-normal text-muted-foreground", children: n.email })
                        ] }),
                        f.filter((l) => l.category === "top").length > 0 && /* @__PURE__ */ s.jsx(ze, {}),
                        f.filter((l) => l.category === "top").map((l) => /* @__PURE__ */ s.jsx(ge, { item: l }, l.label)),
                        f.filter(
                          (l) => !l.category || l.category === "middle"
                        ).length > 0 && /* @__PURE__ */ s.jsx(ze, {}),
                        f.filter(
                          (l) => !l.category || l.category === "middle"
                        ).map((l) => /* @__PURE__ */ s.jsx(ge, { item: l }, l.label)),
                        f.filter((l) => l.category === "bottom").length > 0 && /* @__PURE__ */ s.jsx(ze, {}),
                        f.filter((l) => l.category === "bottom").map((l) => /* @__PURE__ */ s.jsx(ge, { item: l }, l.label))
                      ] })
                    ] }) : /* @__PURE__ */ s.jsx(Se, { variant: "ghost", onClick: () => t.login(), children: "Login" })
                  }
                ),
                /* @__PURE__ */ s.jsx(A.Target, { name: "head-navigation-end" }),
                /* @__PURE__ */ s.jsx($r, {})
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: O("hidden lg:block", m), children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-screen-2xl mx-auto border-transparent relative", children: [
          /* @__PURE__ */ s.jsx(A.Target, { name: "top-navigation-before" }),
          /* @__PURE__ */ s.jsx(Ec, {}),
          /* @__PURE__ */ s.jsx(A.Target, { name: "top-navigation-after" })
        ] }) })
      ]
    }
  );
}), Sr = ({
  shouldScaleBackground: e = !0,
  ...t
}) => /* @__PURE__ */ s.jsx(
  q.Root,
  {
    shouldScaleBackground: e,
    ...t
  }
);
Sr.displayName = "Drawer";
const Zc = q.Trigger, Cc = q.Portal, Zr = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s.jsx(
  q.Overlay,
  {
    ref: r,
    className: O("fixed inset-0 z-50 bg-black/80", e),
    ...t
  }
));
Zr.displayName = q.Overlay.displayName;
const Tc = K.forwardRef(
  ({ className: e, children: t, hideBar: r = !0, ...n }, o) => /* @__PURE__ */ s.jsxs(Cc, { children: [
    /* @__PURE__ */ s.jsx(Zr, {}),
    /* @__PURE__ */ s.jsxs(
      q.Content,
      {
        ref: o,
        className: O(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background",
          e
        ),
        ...n,
        children: [
          !r && /* @__PURE__ */ s.jsx("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
          t
        ]
      }
    )
  ] })
);
Tc.displayName = "DrawerContent";
const Nc = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s.jsx(
  q.Title,
  {
    ref: r,
    className: O(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
Nc.displayName = q.Title.displayName;
const Oc = K.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ s.jsx(
  q.Description,
  {
    ref: r,
    className: O("text-sm text-muted-foreground", e),
    ...t
  }
));
Oc.displayName = q.Description.displayName;
const Cr = ({
  children: e,
  className: t
}) => {
  const { options: r } = M(), n = H(null);
  return F(() => {
    const o = n.current?.querySelector('[aria-current="page"]');
    $n(o ?? null);
  }, []), /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: "grid sticky top-(--header-height) lg:h-[calc(100vh-var(--header-height))] grid-rows-[1fr_min-content] border-r",
      "data-pagefind-ignore": "all",
      children: [
        /* @__PURE__ */ s.jsx(
          "nav",
          {
            ref: n,
            className: O(
              "hidden max-w-[calc(var(--side-nav-width)+var(--padding-nav-item))] lg:flex scrollbar flex-col overflow-y-auto shrink-0 text-sm pe-3 ps-4 lg:ps-8",
              "-mx-(--padding-nav-item) pb-[8vh] pt-(--padding-content-top) scroll-pt-2 gap-1",
              // Revert the padding/margin on the first child
              "-mt-2.5",
              t
            ),
            style: {
              maskImage: "linear-gradient(180deg, transparent 1%, rgba(0, 0, 0, 1) 20px, rgba(0, 0, 0, 1) 90%, transparent 99%)"
            },
            children: e
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: "bg-background border-t p-2 mx-5  gap-2 items-center mt-2 drop-shadow-[0_-3px_1px_rgba(0,0,0,0.015)] hidden lg:[&:has(>_:nth-child(1):last-child)]:flex", children: r.site?.showPoweredBy !== !1 && /* @__PURE__ */ s.jsx(_r, {}) })
      ]
    }
  );
};
Cr.displayName = "NavigationWrapper";
const Ac = ({
  onRequestClose: e,
  navigation: t
}) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsxs(Cr, { children: [
    /* @__PURE__ */ s.jsx(A.Target, { name: "navigation-before" }),
    t.map((r) => /* @__PURE__ */ s.jsx(
      nt,
      {
        item: r
      },
      r.type + (r.label ?? "") + ("path" in r ? r.path : "") + ("file" in r ? r.file : "") + ("to" in r ? r.to : "")
    )),
    /* @__PURE__ */ s.jsx(A.Target, { name: "navigation-after" })
  ] }),
  /* @__PURE__ */ s.jsx(
    Xt,
    {
      className: "lg:hidden h-[100dvh] start-0 w-[320px] rounded-none",
      "aria-describedby": void 0,
      children: /* @__PURE__ */ s.jsxs("div", { className: "p-4 overflow-y-auto overscroll-none", children: [
        /* @__PURE__ */ s.jsx(Jt, { children: /* @__PURE__ */ s.jsx(er, { children: "Navigation" }) }),
        t.map((r) => /* @__PURE__ */ s.jsx(
          nt,
          {
            item: r,
            onRequestClose: e
          },
          r.label
        ))
      ] })
    }
  )
] }), Ic = ({ children: e }) => {
  const [t, r] = G(!1), { navigation: n } = Qt(), o = n.length > 0, i = De().state === "loading", { options: a } = M();
  return /* @__PURE__ */ s.jsxs(
    Sr,
    {
      direction: a.site?.dir === "rtl" ? "right" : "left",
      open: t,
      onOpenChange: (u) => r(u),
      children: [
        o && /* @__PURE__ */ s.jsx(
          Ac,
          {
            onRequestClose: () => r(!1),
            navigation: n
          }
        ),
        o && /* @__PURE__ */ s.jsx("div", { className: "lg:hidden -mx-4 px-4 py-2 sticky bg-background/80 backdrop-blur-xs z-10 top-0 start-0 end-0 border-b", children: /* @__PURE__ */ s.jsxs(Zc, { className: "flex items-center gap-2 px-4", children: [
          /* @__PURE__ */ s.jsx(Vn, { size: 16, strokeWidth: 1.5 }),
          /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: "Menu" })
        ] }) }),
        /* @__PURE__ */ s.jsxs(
          "main",
          {
            "data-pagefind-body": !0,
            className: O(
              "px-4 lg:pe-8 lg:px-8",
              !o && "col-span-full",
              i && "animate-pulse"
            ),
            children: [
              /* @__PURE__ */ s.jsx(A.Target, { name: "content-before" }),
              e,
              /* @__PURE__ */ s.jsx(A.Target, { name: "content-after" })
            ]
          }
        )
      ]
    }
  );
}, Rc = () => /* @__PURE__ */ s.jsx("main", { className: "col-span-full row-span-full grid place-items-center", children: /* @__PURE__ */ s.jsx(Yt, {}) }), Dc = ({ children: e }) => {
  const { meta: t, authentication: r, options: n } = M(), o = xe();
  return zn(), uc(), F(() => {
    r?.onPageLoad?.();
  }, [r]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(Re, { titleTemplate: t?.title, children: [
      n.canonicalUrlOrigin && /* @__PURE__ */ s.jsx(
        "link",
        {
          rel: "canonical",
          href: ee(
            n.canonicalUrlOrigin,
            n.basePath,
            o.pathname
          )
        }
      ),
      t?.description && /* @__PURE__ */ s.jsx("meta", { name: "description", content: t.description }),
      t?.favicon && /* @__PURE__ */ s.jsx("link", { rel: "icon", href: t.favicon })
    ] }),
    /* @__PURE__ */ s.jsx(A.Target, { name: "layout-before-head" }),
    /* @__PURE__ */ s.jsx(Er, {}),
    /* @__PURE__ */ s.jsx(A.Target, { name: "layout-after-head" }),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: O(
          "grid max-w-screen-2xl w-full lg:mx-auto",
          "[&:has(>:only-child)]:grid-rows-1 grid-rows-[0_min-content_1fr] lg:grid-rows-[min-content_1fr]",
          "grid-cols-1 lg:grid-cols-[var(--side-nav-width)_1fr]"
        ),
        children: /* @__PURE__ */ s.jsx(qe, { fallback: /* @__PURE__ */ s.jsx(Rc, {}), children: /* @__PURE__ */ s.jsx(Ic, { children: e ?? /* @__PURE__ */ s.jsx(Dt, {}) }) })
      }
    ),
    /* @__PURE__ */ s.jsx(fc, {})
  ] });
}, Mc = ({
  title: e = "An error occurred",
  message: t,
  category: r
}) => /* @__PURE__ */ s.jsxs(Kt, { className: "h-full pt-(--padding-content-top)", children: [
  r && /* @__PURE__ */ s.jsx(Pn, { children: r }),
  e && /* @__PURE__ */ s.jsx(En, { level: 1, className: "flex gap-3.5 items-center", children: e }),
  /* @__PURE__ */ s.jsx("p", { children: t })
] }), Fc = (e) => {
  switch (e) {
    case 400:
      return {
        title: "Bad Request",
        message: "The request could not be understood by the server due to malformed syntax."
      };
    case 403:
      return {
        title: "Forbidden",
        message: "You don't have permission to access this resource."
      };
    case 404:
      return {
        title: "Not Found",
        message: "The requested resource could not be found."
      };
    case 405:
      return {
        title: "Method Not Allowed",
        message: "The request method is not supported for the requested resource."
      };
    case 414:
      return {
        title: "Request URI Too Large",
        message: "The request URI is too large."
      };
    case 416:
      return {
        title: "Range Not Satisfiable",
        message: "The server cannot satisfy the request range."
      };
    case 500:
      return {
        title: "Internal Server Error",
        message: "An unexpected error occurred while processing your request."
      };
    case 501:
      return {
        title: "Not Implemented",
        message: "The server does not support the functionality required to fulfill the request."
      };
    case 502:
      return {
        title: "Bad Gateway",
        message: "The server received an invalid response from the upstream server."
      };
    case 503:
      return {
        title: "Service Unavailable",
        message: "The server is temporarily unable to handle the request."
      };
    case 504:
      return {
        title: "Gateway Timeout",
        message: "The server did not receive a timely response from the upstream server."
      };
    default:
      return {
        title: "An error occurred",
        message: "Something went wrong while processing your request."
      };
  }
}, qc = ({ statusCode: e, message: t }) => {
  if (e === 404)
    return /* @__PURE__ */ s.jsx(Sn, {});
  const r = Fc(e);
  return /* @__PURE__ */ s.jsx(
    Mc,
    {
      title: r.title,
      message: t ?? r.message,
      category: e
    }
  );
}, Uc = Fe(null), Ee = {
  didCatch: !1,
  error: null
};
class Lc extends Rn {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Ee;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var r, n, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
        i[a] = arguments[a];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: i,
        reason: "imperative-api"
      }), this.setState(Ee);
    }
  }
  componentDidCatch(t, r) {
    var n, o;
    (n = (o = this.props).onError) === null || n === void 0 || n.call(o, t, r);
  }
  componentDidUpdate(t, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: o
    } = this.props;
    if (n && r.error !== null && Qc(t.resetKeys, o)) {
      var i, a;
      (i = (a = this.props).onReset) === null || i === void 0 || i.call(a, {
        next: o,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(Ee);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: o
    } = this.props, {
      didCatch: i,
      error: a
    } = this.state;
    let u = t;
    if (i) {
      const p = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        u = r(p);
      else if (n)
        u = ot(n, p);
      else if (o !== void 0)
        u = o;
      else
        throw a;
    }
    return ot(Uc.Provider, {
      value: {
        didCatch: i,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function Qc() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((r, n) => !Object.is(r, t[n]));
}
let Bc = () => ({
  emit(e, ...t) {
    for (let r = this.events[e] || [], n = 0, o = r.length; n < o; n++)
      r[n](...t);
  },
  events: {},
  on(e, t) {
    return (this.events[e] ||= []).push(t), () => {
      this.events[e] = this.events[e]?.filter((r) => t !== r);
    };
  }
});
const Kc = (e) => Object.entries(e);
class Hc {
  plugins;
  navigation;
  meta;
  site;
  authentication;
  queryClient;
  options;
  navigationPlugins;
  emitter = Bc();
  constructor(t, r) {
    const n = (t.protectedRoutes ?? []).concat(
      t.plugins?.flatMap(
        (o) => st(o) ? o.getProtectedRoutes?.() ?? [] : []
      ) ?? []
    );
    this.queryClient = r, this.options = { ...t, protectedRoutes: n }, this.plugins = t.plugins ?? [], this.navigation = t.navigation ?? [], this.navigationPlugins = this.plugins.filter(st), this.authentication = this.plugins.find(Gn), this.meta = t.metadata, this.site = t.site, this.plugins.forEach((o) => {
      Jn(o) && Kc(o.events).forEach(([i, a]) => {
        this.emitter.on(i, a);
      });
    }), gn.subscribe((o, i) => {
      this.emitEvent("auth", {
        prev: i,
        next: o
      });
    });
  }
  initialize = async () => {
    await Promise.all(
      this.plugins.filter(Xn).map((t) => t.initialize?.(this))
    );
  };
  getApiIdentities = async () => (await Promise.all(
    this.plugins.filter(eo).map((r) => r.getIdentities(this))
  )).flat();
  addEventListener(t, r) {
    return this.emitter.on(t, r);
  }
  emitEvent = (t, ...r) => this.emitter.emit(t, ...r);
  getPluginNavigation = async (t) => (await Promise.all(
    this.navigationPlugins.map(
      (n) => n.getNavigation?.(ee(t), this)
    )
  )).flatMap((n) => n ?? []);
  getProfileMenuItems = () => this.plugins.filter((r) => Gt(r)).flatMap((r) => r.getProfileMenuItems(this)).sort(Wc(["top", "middle", "bottom"])).sort((r) => r.weight ?? 0);
  signRequest = async (t) => {
    if (!this.authentication)
      throw new Error("No authentication provider configured");
    return await this.authentication.signRequest(t);
  };
}
const Wc = (e) => (t, r) => {
  const n = e.indexOf(t.category ?? "middle"), o = e.indexOf(r.category ?? "middle");
  return n - o;
};
function Vc({ error: e, resetErrorBoundary: t }) {
  return /* @__PURE__ */ s.jsx(Bt, { error: e });
}
const me = globalThis;
(!me.requestIdleCallback || !me.cancelIdleCallback) && (me.requestIdleCallback = (e) => setTimeout(e, 1), me.cancelIdleCallback = clearTimeout);
const Tr = {
  Header: Er
}, Yc = Fe(Tr), Gc = Yc.Provider, Jc = () => {
  const e = xe(), t = M(), r = H(void 0);
  return F(() => {
    t.emitEvent("location", {
      from: r.current,
      to: e
    }), r.current = e;
  }, [t, e]), null;
}, Xc = ({
  children: e,
  context: t
}) => (vn({
  queryFn: async () => (await t.initialize(), !0),
  queryKey: ["zudoku-initialize", yn]
}), /* @__PURE__ */ s.jsx(xn.Provider, { value: t, children: e }));
let Ot;
const Nr = Vt(
  ({ children: e, ...t }) => {
    const r = $e(
      () => ({ ...Tr, ...t.overrides }),
      [t.overrides]
    ), n = xe(), o = $e(() => ({
      ...(t.plugins ?? []).filter(to).flatMap(
        (l) => l.getMdxComponents ? [l.getMdxComponents()] : []
      ).reduce(
        (l, g) => ({ ...l, ...g }),
        {}
      ),
      ...Zn,
      ...t.mdx?.components
    }), [t.mdx?.components, t.plugins]), { stagger: i } = Dn(Ze), [a, u] = G(!1), p = $e(
      () => a ? { stagger: !0 } : { stagger: i },
      [i, a]
    ), f = De(), x = qt();
    F(() => {
      a || u(!0);
    }, [a, f.location]), Ot ??= new Hc(t, x);
    const h = t.plugins?.flatMap(
      (m) => ro(m) ? m.getHead?.({ location: n }) ?? [] : []
    ).map((m, l) => /* @__PURE__ */ s.jsx(Re, { children: m }, l));
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      h,
      /* @__PURE__ */ s.jsx(Ze.Provider, { value: p, children: /* @__PURE__ */ s.jsxs(Xc, { context: Ot, children: [
        /* @__PURE__ */ s.jsx(Jc, {}),
        /* @__PURE__ */ s.jsx(Cn, { slots: t.slots ?? t.UNSAFE_slotlets, children: /* @__PURE__ */ s.jsx(Xr, { components: o, children: /* @__PURE__ */ s.jsx(en, { attribute: "class", disableTransitionOnChange: !0, children: /* @__PURE__ */ s.jsx(Gc, { value: r, children: /* @__PURE__ */ s.jsx(Tn, { children: e ?? /* @__PURE__ */ s.jsx(Dt, {}) }) }) }) }) })
      ] }) })
    ] });
  }
);
Nr.displayName = "ZudokoInner";
const Or = (e) => /* @__PURE__ */ s.jsx(Lc, { FallbackComponent: Vc, children: /* @__PURE__ */ s.jsx(Nr, { ...e }) });
Or.displayName = "Zudoku";
const _u = Dc, bu = Nn, wu = wo, ju = $o, ku = zo, $u = Jr, zu = Re, Pu = qc, Eu = An, Su = On, Zu = Yt, Cu = te, Tu = Ht, Nu = Me, Ou = cc, Au = Or, Iu = Kt, Ru = tn, eu = M, Du = oe, Mu = _n, Fu = bn, qu = Rt;
export {
  Tu as B,
  Eu as C,
  zu as H,
  Nu as L,
  Su as M,
  bu as R,
  Zu as S,
  Iu as T,
  Au as Z,
  $c as a,
  Du as b,
  _u as c,
  wu as d,
  ju as e,
  ku as f,
  $u as g,
  Pu as h,
  Cu as i,
  Ou as j,
  Ru as k,
  Mu as l,
  Fu as m,
  qu as n,
  Kc as o,
  eu as u
};
//# sourceMappingURL=index-D09PbNex.js.map
